import React, { ReactElement, Component, useState, useEffect, useContext, useCallback, useMemo, useRef, Fragment } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import "./table-list-modal.less";
import { Col, Input, Button, Select, Empty, AutoComplete, Form, Modal, Descriptions, Table, Divider, notification, Checkbox, Switch, Row, Tooltip, Tabs, Radio, Collapse } from "antd";
import { withRouter } from "react-router-dom";
import AceEditor from "react-ace";
import "brace/ext/language_tools";
// 兼容ie浏览器
import "brace/ext/old_ie";
//searchbox过滤框，快捷键ctrl+F
import "brace/ext/searchbox";
import "brace/mode/yaml";
import "brace/mode/html";
import "brace/mode/css";
import "brace/theme/monokai";
import { item, ItemsContext } from "../../contexts/items";
import { change_unit } from "../../pages/global/global";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { http_request, response_type } from "../../worker/http-func";
import { worker_fetch } from '../../worker/worker-fetch';
import { workspaces_type_item, WorkspaceContext } from "../../contexts/workspaces";
import { quota_type, QuotaContext, quota_type_item } from "../../contexts/quota-management";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { ItemSelectedContext } from "../../contexts/item-selected";
import FileSaver from "file-saver";
import { TypeNameContext } from "../../contexts/type_name";
import { UsernameLoginContext } from "../../contexts/username-login";
import TextArea from "antd/lib/input/TextArea";
import { loading_type, user_subscription_all, TableListModalContext } from "../table-list/table-list";
import { table_list_modal_type } from "../../contexts/table_list_modal";
import Text from "antd/lib/typography/Text";
import { LoadingOutlined, SyncOutlined, DownloadOutlined, CloseCircleOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { Option } from "rc-select";
import yaml from "js-yaml";
import { key_value } from "../../pages/workspaces-list/quota_scale";
import { WorkSpaceSelectContext } from "../../contexts/workspace-select";
import { ingress_type_item, rule_type_item, event_type_item } from "../../contexts/ingress";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { UnitContext } from "../../contexts/unit";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { EnvContext } from "../../contexts/env";
import { datacenter_url } from "../../components/top-navbar/interface";
import { SortFirstContext } from "../../contexts/sort-first";
import { ThemeContext } from "../../components/../contexts/theme";
import { to_right } from "../../img";
import { RefreshWorkloadsContext, refresh_workloads_type } from "../../contexts/refresh-worloads";
// import { PodSelectedContext } from "../../contexts/pod_seleted";
import { containers_type_item } from "../../pages/workload-list/workload-list";
import { IsFreshContext } from "../../contexts/is_fresh";
import { permissions, permission_in_roles_array } from "../../permissions";
import { subscriptionType } from "../../pages/service/common-file/interfaceType";
import { EnableAutoscaleContext } from "../../contexts/enable-autoscale";
import { useDeepCompareMemo } from 'use-deep-compare';
import { get_time } from "../../shared-functions";
import {format_time} from '../../pages/applications/common-file/service';

interface config {
  apiVersion: string;
  kind: string;
  clusters: {
    cluster: {
      "certificate-authority-data": string;
      "insecure-skip-tls-verify": boolean;
      server: string;
    };
    name: string;
  }[];
  users: {
    user: {
      "client-certificate-data": string;
      "client-key-data": string;
      token: string;
    };
    name: string;
  }[];
  contexts: {
    context: {
      cluster: string;
      user: string;
    };
    name: string;
  }[];
  "current-context": string;
}

interface labels {
  workspace?: string;
  namespacequota?: string;
  type?: string;
  bindcpunodes?: string;
  bindgpunodes?: string
}

interface spec extends spec_config {
  quotas?: quotas;
  workspacequota?: string;
}

interface spec_config {
  clientcert?: {
    cert: string;
    key: string;
  };
  host?: string;
  cacert?: string;
  token?: string;
}

interface quotas {
  "limits.cpu"?: string;
  "limits.memory"?: string;
  "limits.ephemeral-storage"?: string;
  pods?: string;
  "requests.storage"?: string;
  persistentvolumeclaims?: string;
  services?: string;
  secrets?: string;
  configmaps?: string;
}

interface logs {
  logs?: string;
}

interface event_new {
  name: string;
  uid: string;
  key: string;
  creationTimestamp: string;
  description?: string;
  cause?: string;
  type: string;
  object: string;
}

interface autoScale_subsription_type {
  subscriptionId: string;
}

const persistent_page: string[] = ['storage-info/pv', 'storage-info/pvc', 'storage-info/storage'];

export const input_regexp = (key: number, val: any, fun: React.Dispatch<React.SetStateAction<any>>, result?: boolean) => {
    let msg: any = '';
    switch (key) {
        case 1:
            /^[a-zA-Z0-9.-]+$/.test(val) && (msg = 'input_regexp_1');
            break;
        case 2:
            !/^[^.-](.*[^.-])?$/.test(val) && (msg = 'input_regexp_2');
            break;
        case 3:
            !/^[0-9]+$/.test(val) && (msg = 'input_regexp_3');
            break;
        case 4:
            !/^[a-f0-9-]+$/.test(val) && (msg = 'input_regexp_4');
            break;
        case 5:
            !/^[0-9.:,]+$/.test(val) && (msg = 'input_regexp_5');
            break;
        case 6:
            !/^[a-z0-9.-]+$/.test(val) && (msg = 'input_regexp_6');
            break;
        case 7:
            !/^[a-zA-Z0-9-._\s]+$/.test(val) && (msg = 'input_regexp_7');
            break;
        case 8:
            !/^[a-zA-Z0-9._-]+$/.test(val) && (msg = 'input_regexp_8');
            break;
        case 9:
            !/^[\S]+$/.test(val) && (msg = 'input_regexp_9');
            break;
        case 10:
            !/^[a-zA-z0-9_\-.+]+$/.test(val) && (msg = 'input_regexp_10');
            break;
        case 11:
            !/^[a-zA-Z0-9_\-./@:]+$/.test(val) && (msg = 'input_regexp_11');
            break;
        case 12:
            !/^(?!Shared$)/.test(val) && (msg = 'input_regexp_12');
            break;
        case 13:
            (val === '.' || val === '..') && (msg = 'input_regexp_13');
            break;
        case 14:
            !/^[a-z]{1,}[a-zA-z0-9.-]{0,}$/.test(val) && (msg = 'input_regexp_14');
            break;
        default:
            break;
    }
    fun({
        status: msg ? 'error' : 'success',
        msg: msg ? <FormattedMessage id={msg}/> : null,
    });
    return result && msg;
};

const TableListModal: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const {history} = props,
    items: item[] = useContext(ItemsContext)[0],
    [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(
      WorkspaceContext
    ),
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      WorkSpaceSelectedContext
    ),
    [quotas, set_quotas]: [quota_type["items"], React.Dispatch<React.SetStateAction<quota_type["items"]>>] = useContext(QuotaContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
    item_selected: item = useContext(ItemSelectedContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    username_login: string | undefined = useContext(UsernameLoginContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    type_name: string | undefined = useContext(TypeNameContext)[0],
    workspace_select: JSX.Element[] = useContext(WorkSpaceSelectContext)[0],
    [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
      TableListModalContext
    ),
    set_sort_first: React.Dispatch<React.SetStateAction<string>> = useContext(SortFirstContext)[1],
    set_refresh_workloads: React.Dispatch<React.SetStateAction<refresh_workloads_type | undefined>> = useContext(RefreshWorkloadsContext)[1],
    theme: string = useContext(ThemeContext)[0],
    path = props.history.location.pathname.substring(1),
    env: datacenter_url | undefined = useContext(EnvContext)[0],
    [is_fresh, set_is_fresh]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(IsFreshContext),
    enable_autoscale: string = useContext(EnableAutoscaleContext)[0],
    // pod_selected: item | undefined = useContext(PodSelectedContext)[0],
    [assign_list, set_assign_list]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [workspace_input, set_workspace_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState(<p></p>),
    [workspace_new, set_workspace_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(""),
    [quota_info_list, set_quota_info_list]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [options, set_options]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([""]),
    [assign_item_selected, set_assign_item_selected]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    // [container_selected, set_container_selected]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>(""),
    [gpu_input, set_gpu_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
      <p></p>),
    [cpu_input, set_cpu_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [cpu_request_input, set_cpu_request_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
      <p></p>),
    [memory_input, set_memory_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [memory_request_input, set_memory_request_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
      <p></p>),
    [rootfs_input, set_rootfs_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [rootfs_request_input, set_rootfs_request_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
      <p></p>),
    [pod_input, set_pod_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [pvc_input, set_pvc_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [pv_input, set_pv_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [service_input, set_service_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [secret_input, set_secret_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [configmap_input, set_configmap_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [name_new, set_name_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [gpu_new, set_gpu_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [cpu_new, set_cpu_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [cpu_request_new, set_cpu_request_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [memory_new, set_memory_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [memory_request_new, set_memory_request_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [rootfs_new, set_rootfs_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [rootfs_request_new, set_rootfs_request_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [pod_new, set_pod_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [pvc_new, set_pvc_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [pv_new, set_pv_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [service_new, set_service_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [secret_new, set_secret_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [configmap_new, set_configmap_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [config_new, set_config_new]: [config, React.Dispatch<React.SetStateAction<config>>] = useState<config>({} as config),
    [type_selected, set_type_selected]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("dedicate"),
    [logs, set_logs]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>(),
    [ingress_new, set_ingress_new]: [ingress_type_item | undefined, React.Dispatch<React.SetStateAction<ingress_type_item | undefined>>] = useState<
      ingress_type_item | undefined
    >(),
    [ingress_event, set_ingress_event]: [event_type_item[] | undefined, React.Dispatch<React.SetStateAction<event_type_item[] | undefined>>] = useState<
      event_type_item[] | undefined
    >(),
    [loading, set_loading]: [loading_type, React.Dispatch<React.SetStateAction<loading_type>>] = useState<loading_type>({} as loading_type),
    [config_string, set_config_string]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>(),
    [persistent_name_val, set_persistent_name_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
    [persistent_name_input, set_persistent_name_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_type_val, set_persistent_type_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('Ceph'),
    [persistent_type_input, set_persistent_type_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_visit_val, set_persistent_visit_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('ReadWriteOnce'),
    [persistent_visit_input, set_persistent_visit_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_recycle_val, set_persistent_recycle_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('Retain'),
    [persistent_recycle_input, set_persistent_recycle_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_bind_val, set_persistent_bind_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
    [persistent_bind_input, set_persistent_bind_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_total_unit, set_persistent_total_unit]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('Mi'),
    [persistent_total_val, set_persistent_total_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
    [persistent_total_input, set_persistent_total_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_parameter_arr, set_persistent_parameter_arr]: [number[], React.Dispatch<React.SetStateAction<number[]>>] = useState<number[]>([]),
    [persistent_parameter_val, set_persistent_parameter_val]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
    [persistent_parameter_input, set_persistent_parameter_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_already_arr, set_persistent_already_arr]: [number[], React.Dispatch<React.SetStateAction<number[]>>] = useState<number[]>([]),
    [persistent_already_val, set_persistent_already_val]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
    [persistent_already_input, set_persistent_already_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_distribution_val, set_persistent_distribution_val]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(1),
    [persistent_distribution_input, set_persistent_distribution_input]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [persistent_tabs_val, set_persistent_tabs_val]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('form-input'),
    [persistent_yaml_val, set_persistent_yaml_val]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
    [persistent_yaml_edit_val, set_persistent_yaml_edit_val]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
    [storage_class_list, set_storage_class_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>([]),
    [storage_class_selected, set_storage_class_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({}),
    [storage_row_selected, set_storage_row_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>([]),
    [cpu_node_list, set_cpu_node_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>([]),
    [gpu_node_list, set_gpu_node_list]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>([]),
    [cpu_node_selected, set_cpu_node_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(null),
    [gpu_node_selected, set_gpu_node_selected]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>(null),
    [persistent_total_validate, set_persistent_total_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [name_validate, set_name_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [gpu_validate, set_gpu_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [cpu_validate, set_cpu_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [cpu_request_validate, set_cpu_request_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [memory_validate, set_memory_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [memory_request_validate, set_memory_request_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [rootfs_validate, set_rootfs_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [rootfs_request_validate, set_rootfs_request_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
        status: "",
        msg: null,
    }),
    [pod_validate, set_pod_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [pvc_validate, set_pvc_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [pv_validate, set_pv_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [service_validate, set_service_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [secret_validate, set_secret_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [configmap_validate, set_configmap_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [user_subscriptions_menu, set_user_subscriptions_menu]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(
      <Form.Item key="user_subscriptions" label={<FormattedMessage id="subscription_name" />} labelCol={{ sm: 10 }} wrapperCol={{ sm: 14 }} required>
        <Select value="Loading" />
      </Form.Item>
    ),
    [user_subscriptions, set_user_subscriptions]: [
      user_subscription_all[] | undefined,
      React.Dispatch<React.SetStateAction<user_subscription_all[] | undefined>>
    ] = useState<user_subscription_all[] | undefined>(),
    [subscription_id_local, set_subscription_id_local]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<
      string | undefined
    >(),
    [nginx_controller_checked, set_nginx_controller_checked]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [cluster_agent_checked, set_cluster_agent_checked]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [log_slave_checked, set_log_slave_checked]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [rms_checked, set_rms_checked]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [support_https_checked, set_support_https_checked]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [ssh_user_new, set_ssh_user_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [pravite_key_new, set_pravite_key_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [image_version_new, set_image_version_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [ip_address_new, set_ip_address_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [request_storage_new, set_request_storage_new]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("32G"),
    [cluster_init_name_validate, set_cluster_init_name_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [pravite_key_validate, set_pravite_key_validate]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      status: "",
      msg: null,
    }),
    [scale_replica, set_scale_replica]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      type: "",
      name: "",
      scale: "",
    }),
    [wk_edit_yaml_data, set_wk_edit_yaml_data]: [object | undefined, React.Dispatch<React.SetStateAction<object | undefined>>] = useState<object | undefined>(undefined),
    [wk_edit_yaml_new, set_wk_edit_yaml_new]: [any, React.Dispatch<React.SetStateAction<any>>] = useState<any>({
      type: "",
      name: "",
      content: null,
    }),
    // [edit_yaml_disabled, set_edit_yaml_disabled]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
    [containers, set_containers]: [containers_type_item[] | undefined, React.Dispatch<React.SetStateAction<containers_type_item[] | undefined>>] = useState<containers_type_item[] | undefined>(),
    [podName_selected, set_podName_selected]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>(""),
    [containerName_selected, set_containerName_selected]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState<string | undefined>(""),
    [workspace_auto_scale, set_workspace_auto_scale]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [wk_auto_scale, set_wk_auto_scale]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [wk_auto_scale_false, set_wk_auto_scale_false]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
    [wk_min_quota, set_wk_min_quota]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [wk_max_quota, set_wk_max_quota]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [wk_timeout, set_wk_timeout]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>("10"),
    [wk_autoscale_workspaceQuota, set_wk_autoscale_workspaceQuota]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [worksapce_default_quota, set_worksapce_default_quota]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [namespace_default_quota, set_namespace_default_quota]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),

    autoQuotas = useMemo(()=>[
      "500m2g-wq", "1c4g-wq", "1c500m6g-wq", "2c8g-wq", "2c500m10g-wq", "3c12g-wq", "3c500m14g-wq", "4c16g-wq", "4c500m18g-wq", "5c20g-wq", "5c500m22g-wq", "6c24g-wq", "6c500m26g-wq", "7c28g-wq", "7c500m30g-wq", "8c32g-wq"
    ],[]),
    autoQuotasInfo = useMemo(() => [{
      name: "500m2g-wq", info: {
        limitCPU: "0.5", limitMemory: "2048", pods: "7", limitsRootfs: "10240", services: "1000", configmaps: "1000", secrets: "1000",persistentvolumeclaims: "0", limitsDisk: "0"}}, { name: "1c4g-wq", info: { limitCPU: "1", limitMemory: "4096", pods: "14", limitsRootfs: "20480", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "1c500m6g-wq", info: { limitCPU: "1.5", limitMemory: "6144", pods: "21", limitsRootfs: "30720", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "2c8g-wq", info: { limitCPU: "2", limitMemory: "8192", pods: "28", limitsRootfs: "40960", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "2c500m10g-wq", info: { limitCPU: "2.5", limitMemory: "10240", pods: "35", limitsRootfs: "51200", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "3c12g-wq", info: { limitCPU: "3", limitMemory: "12288", pods: "42", limitsRootfs: "61440", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "3c500m14g-wq", info: { limitCPU: "3.5", limitMemory: "14336", pods: "49", limitsRootfs: "71680", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "4c16g-wq", info: { limitCPU: "4", limitMemory: "16384", pods: "56", limitsRootfs: "81920", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "4c500m18g-wq", info: { limitCPU: "4.5", limitMemory: "18432", pods: "63", limitsRootfs: "92160", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "5c20g-wq", info: { limitCPU: "5", limitMemory: "20480", pods: "70", limitsRootfs: "102400", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "5c500m22g-wq", info: { limitCPU: "5.5", limitMemory: "22528", pods: "77", limitsRootfs: "112640", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "6c24g-wq", info: { limitCPU: "6", limitMemory: "24576", pods: "84", limitsRootfs: "122880", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "6c500m26g-wq", info: { limitCPU: "6.5", limitMemory: "26624", pods: "91", limitsRootfs: "133120", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "7c28g-wq", info: { limitCPU: "7", limitMemory: "28672", pods: "98", limitsRootfs: "143360", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "7c500m30g-wq", info: { limitCPU: "7.5", limitMemory: "30720", pods: "105", limitsRootfs: "153600", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }, { name: "8c32g-wq", info: { limitCPU: "8", limitMemory: "32768", pods: "110", limitsRootfs: "163840", services: "1000", configmaps: "1000", secrets: "1000", persistentvolumeclaims: "0", limitsDisk: "0" } }
    ],[]),
    timeoutOptions = ['10', '20', '30', '40'],
    [wk_auto_scale_disabled, set_wk_auto_scale_disabled]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    set_functions: { [key: string]: React.Dispatch<React.SetStateAction<any>> } = useMemo(
      () => ({
        workspaces: set_workspaces,
        namespaces: set_namespaces,
        workspacequotas: set_quotas,
        namespacequotas: set_quotas,
      }),
      [set_namespaces, set_quotas, set_workspaces]
    ),
    position: number = useMemo(() => path.lastIndexOf("/") + 1, [path]),
    list_type: string = useMemo(() => path.substr(position, path.length - position).replace(/-/gi, ""), [path, position]),
    permission = useMemo(() => {
      return (list_type === "workspaces" && user_info.role && user_info.role !== "" && (permissions[list_type] as permission_in_roles_array)[user_info.role]) || new Int32Array();
    }, [list_type, user_info.role]),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    has_local_user_subscription: boolean = useMemo(
      () => user_info.is_globaladmin && ((type_name === "shared" && path.includes("workspaces")) || path.includes("clusters")),
      [user_info.is_globaladmin, path, type_name]
    ),
    handler: React.MutableRefObject<NodeJS.Timeout | undefined> = useRef<NodeJS.Timeout | undefined>(),
    footer = useMemo(
      (): object =>
        table_list_modal.visible &&
          (table_list_modal.is_logs || table_list_modal.is_config || table_list_modal.is_details || table_list_modal.is_yaml || table_list_modal.is_web_kubectl || table_list_modal.is_edit_yaml || table_list_modal.is_view_yaml || table_list_modal.is_restartLogs)
          ? { footer: null }
          : {},
      [
        table_list_modal.is_logs,
        table_list_modal.is_config,
        table_list_modal.visible,
        table_list_modal.is_details,
        table_list_modal.is_yaml,
        table_list_modal.is_web_kubectl,
        table_list_modal.is_edit_yaml,
        table_list_modal.is_view_yaml,
        table_list_modal.is_restartLogs,
      ]
    ),
    // 驗證name輸入框
    name_validate_exam = useCallback(
      async (name: string): Promise<void> => {
        handler.current && clearTimeout(handler.current);
        const is_workspace_namespace = path.includes("workspaces") || path.includes("namespaces");
        const has_special_characters: boolean = is_workspace_namespace ? !RegExp(/^([0-9a-z]{1,16})$/).test(name) : !RegExp(/^[a-z0-9.-]+$/).test(name),
          has_special_characters_beginning_end: boolean = !RegExp(/^[a-z0-9](.*[a-z0-9])?$/).test(name);
        if (has_special_characters) {
          if (name.length > 0)
            set_name_validate({
              status: "error",
              msg: `${is_workspace_namespace ? formatMessage({ id: "workspace_create_tip" }) : formatMessage({ id: "workspace_create_tip_else" })}`,
            });
          else set_name_validate({ status: "error", msg: formatMessage({ id: "this_field_is_required" }) });
          set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }));
        } else if (has_special_characters_beginning_end) {
          if (name.length > 0) set_name_validate({ status: "error", msg: formatMessage({ id: ".and-should_not_be_at_the_beginning_or_end" }) });
          set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }));
        } else {
          let invalid: boolean = false,
            chech_taken = (items: any[], is_ws?: boolean): { status: string; msg: string | undefined } => {
              invalid = Array.isArray(items)
                ? items.filter((item: any) => (is_ws ? item.metadata.labels || item : item.metadata || item).name === name).length > 0
                : false;
              return invalid ? { status: "error", msg: formatMessage({ id: "the_name_has_been_taken" }) } : { status: "success", msg: undefined };
            };
          switch (path) {
            case "cluster-info/workspaces":
              workspaces && set_name_validate(chech_taken(workspaces, true));
              break;
            case "quotas/workspace-quotas":
            case "quotas/namespace-quotas":
              set_name_validate(chech_taken(quotas));
              break;
            case "clusters":
            case "workspace-info/namespaces":
            case "nodes":
            case "storages/storage-classes":
              set_name_validate(chech_taken(items));
              break;
          }

          if (path === "workspace-info/namespaces") {
            if (!invalid) {
              set_name_validate({ status: "validating", msg: undefined });
              invalid = await new Promise((resolve: (value: boolean) => void): void => {
                handler.current = setTimeout(async () => {
                  resolve(
                    !!(
                      cluster_selected?.name &&
                      name &&
                      datacenter_name &&
                      ((await http_request(
                        "existence",
                        props,
                        undefined,
                        `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/namespace/${name}/existence`,
                        0,
                        user_info.role,
                        subscription_id_local,
                        datacenter_name,
                        cluster_selected.name,
                        undefined,
                        undefined,
                        true,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        true
                      )) as { exist: boolean })?.exist
                    ) as boolean
                  );
                }, 500);
              });
              set_name_validate(invalid ? { status: "error", msg: formatMessage({ id: "the_name_has_been_taken" }) } : { status: "success", msg: undefined });
            }
          }

          set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: invalid }));
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [items, path, quotas, workspaces, cluster_selected, datacenter_name, user_info.role, subscription_id_local, set_table_list_modal, formatMessage]
    ),
    openNotification = useCallback(
      (type: string) => {
        if (type === "error") {
          notification.open({
            message: formatMessage({ id: "error" }),
            description: formatMessage({ id: "download_config_error" }),
            icon: <CloseCircleOutlined style={{ color: "#FF4D4F" }} />,
          });
        }
      },
      [formatMessage]
    ),
    // 下載config檔（之後須移到最上層）
    download_config = useCallback(
      (e: any) => {
        e.stopPropagation();
        (async () => {
          let config: any, blob: any;
          const type = "data:application/json;charset=utf-8";
          try {
            const cluster_config: any =
              datacenter_name &&
              (await fetch(`/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name || sessionStorage.getItem("cluster")}/config?type=string`, {
                credentials: "include",
                method: "GET",
              }));
            // config = await cluster_config.text();
            if (cluster_config?.status >= 200 && cluster_config?.status < 299) {
              config = await cluster_config.text();
            } else {
              config = await cluster_config.text();
              openNotification("error");
            }
          } catch {
            config = "API response Error";
            openNotification("error");
          }
          blob = new Blob([config], { type: type });
          let isFileSaverSupported = false;
          try {
            isFileSaverSupported = !!new Blob();
          } catch (e) {
            console.error(e);
          }

          isFileSaverSupported && FileSaver.saveAs(blob, cluster_selected?.name || sessionStorage.getItem("cluster") || "");
        })();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [cluster_selected?.name, datacenter_name, openNotification]
    ),
    assign = useCallback(
      async (quota_name: string | undefined): Promise<void> => {
        if (user_info.role && datacenter_name) {
          (await path.includes("workspace"))
            ? http_request(
              "scalequotas",
              props,
              set_workspaces,
              `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${workspace_selected?.name}`,
              2,
              user_info.role,
              user_info.subscription_id,
              datacenter_name,
              (cluster_selected || {}).name || "",
              { metadata: { 
                name: workspace_selected?.labels?.name, 
                labels: workspace_selected?.labels,
               }, spec: { workspacequota: quota_name } }
            )
            : http_request(
              "scalequotas",
              props,
              set_namespaces,
              `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/namespace/${namespace_selected?.name}`,
              2,
              user_info.role,
              user_info.subscription_id,
              datacenter_name,
              (cluster_selected || {}).name || "",
              { metadata: { labels: { namespacequota: table_list_modal.is_unassign_quota ? undefined : quota_name, workspace: workspace_selected?.name } } }
            );
          const item_selected_new = item_selected;
          item_selected_new.quotaName = quota_name;
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        cluster_selected,
        item_selected,
        namespace_selected,
        path,
        user_info.role,
        set_namespaces,
        set_workspaces,
        user_info.subscription_id,
        workspace_selected,
        datacenter_name,
        table_list_modal.is_unassign_quota
      ]
    ),
    pod_dropdown: JSX.Element[] = useMemo((): JSX.Element[] => {
      const { logs }: loading_type = loading;
      const podNamesList: string[] = [];
      if (item_selected?.podNames) {
        item_selected?.podNames.map((item: string) => {
          return podNamesList.push(item)
        })
      }
      if (item_selected?.unhealthyPodNames) {
        item_selected?.unhealthyPodNames.map((item: string) => {
          return podNamesList.push(item)
        })
      }
      return [
        <span key="pods_label">Pods:</span>,
        <Select
          key="pods_select"
          className="pl-20 mx-10 w-25"
          value={podName_selected || (podNamesList && podNamesList[0])}
          onChange={(e: any) => {
            set_podName_selected(e);
            set_containerName_selected(undefined);
            set_containers(undefined);
            set_logs(undefined);
          }}
        >
          {podNamesList?.map((pod_name: string) => (
            <Option value={pod_name} key={pod_name}>
              {pod_name}
            </Option>
          ))
          }
        </Select>,
        <span key="1">Containers:</span>,
        <Select
          key="2"
          className="pl-20 mx-10 w-25"
          value={containerName_selected || (containers || [])[0]?.name}
          onChange={(e: any) => {
            set_containerName_selected(e);
            set_loading({ logs: true });
          }}
        >
          {containers?.map((container_item: any) => (
            <Option value={container_item?.name} key={container_item?.name}>
              {container_item?.name}
            </Option>
          ))}
        </Select>,
        <Button
          key="3"
          className="ml-10"
          onClick={() => {
            set_loading({ logs: true });
          }}
        >
          {logs ? <LoadingOutlined spin /> : <SyncOutlined />}
        </Button>,
      ];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formatMessage, containers, podName_selected, item_selected?.name, containerName_selected, loading]),
    // 詢問視窗按OK
    handle_ok: () => void = useCallback(async (): Promise<void> => {
if (table_list_modal.action === 1 && list_type === 'workspacequotas') {
        if (!(cpu_new.length && memory_new.length && rootfs_new)) {
            !cpu_new.length && set_cpu_validate({
                status: "error",
                msg: formatMessage({id: "this_field_is_required"})
            });
            !memory_new.length && set_memory_validate({
                status: "error",
                msg: formatMessage({id: "this_field_is_required"})
            });
            !rootfs_new && set_rootfs_validate({
                status: "error",
                msg: formatMessage({id: "this_field_is_required"})
            });
            return
        }
        if (
            (cpu_validate.status && cpu_validate.status !== 'success') ||
            (memory_validate.status && memory_validate.status !== 'success') ||
            (rootfs_validate.status && rootfs_validate.status !== 'success')
        ) return;
    }

    const clean_form = () => {
        set_persistent_total_validate({status: "", msg: null});
        set_name_validate({status: "", msg: null});
        set_memory_validate({status: "", msg: null});
        set_memory_request_validate({status: "", msg: null});
        set_gpu_validate({status: "", msg: null});
        set_cpu_validate({status: "", msg: null});
        set_cpu_request_validate({status: "", msg: null});
        set_rootfs_validate({status: "", msg: null});
        set_rootfs_request_validate({status: "", msg: null});
        set_pod_validate({status: "", msg: null});
        set_pvc_validate({status: "", msg: null});
        set_pv_validate({status: "", msg: null});
        set_service_validate({status: "", msg: null});
        set_configmap_validate({status: "", msg: null});
        set_secret_validate({status: "", msg: null});
        set_table_list_modal((currentState) => ({...currentState, visible: false}));
        set_gpu_new("");
        set_cpu_new("");
        set_cpu_request_new("");
        set_rootfs_new("");
        set_rootfs_request_new("");
        set_pod_new("");
        set_pvc_new("");
        set_pv_new("");
        set_service_new("");
        set_secret_new("");
        set_configmap_new("");
        set_persistent_parameter_arr([]);
        set_persistent_parameter_val({});
        set_persistent_already_arr([]);
        set_persistent_already_val({});
        set_persistent_name_val('');
        set_persistent_type_val('Ceph');
        set_persistent_total_val('');
        set_persistent_visit_val('ReadWriteOnce');
        set_persistent_recycle_val('Retain');
        set_persistent_bind_val('');
        set_persistent_total_unit('Mi');
        set_persistent_distribution_val(1);
        set_persistent_yaml_val({});
        set_persistent_yaml_edit_val({});
        set_persistent_tabs_val('form-input');
        set_cpu_node_list([]);
        set_gpu_node_list([]);
        set_cpu_node_selected('');
        set_gpu_node_selected('');
    };

    if (persistent_page.find((val: string) => path.includes(val))) {
        const persistent_action = table_list_modal.action;
        let api_result: any;
        if(persistent_action === 0) {
            let yaml_data: any = {};
            if(persistent_tabs_val === 'yaml-input'){
                try {
                    yaml_data = yaml.safeLoad(persistent_yaml_edit_val);
                    set_persistent_yaml_val(yaml_data);
                }catch (e) {
                    notification.error({message: e.name, description: e.message});
                    return;
                }
            }
            const test1: boolean = input_regexp(14, persistent_name_val, set_name_validate, true),
                test2: boolean = input_regexp(9, persistent_name_val, set_name_validate, true),
                test3: boolean = input_regexp(3, persistent_total_val, set_persistent_total_validate, true),
                test4: boolean = input_regexp(9, persistent_total_val, set_persistent_total_validate, true);
            if (persistent_tabs_val === 'form-input' && (test1 || test2 || test3 || test4)) {
                return
            } else if(list_type === 'pvc' && storage_row_selected.length <= 0 && persistent_tabs_val === 'form-input'){
                notification.error({
                    message: formatMessage({id: 'error'}),
                    description: formatMessage({id: 'sc_is_required'})
                });
                return;
            }else {
                set_table_list_modal((currentState) => ({
                    ...currentState,
                    modal_ok_button: true
                }));
                const new_parameter: any = (() => {
                    const new_data: any = {};
                    // eslint-disable-next-line
                    persistent_parameter_arr.map((item: number) => {
                        const new_key: any = persistent_parameter_val[`persistent_parameter_key_${item}`],
                            new_val: any = persistent_parameter_val[`persistent_parameter_val_${item}`];
                        new_key && new_val && (new_data[new_key] = new_val);
                    });
                    return new_data;
                })();
                let persistent_url: string = '',
                    persistent_body: any = {};
                switch (list_type) {
                    case 'pv':
                        persistent_url = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/namespace/000/pv`;
                        // if(persistent_total_val === 'NFS'){
                        persistent_body = {
                            metadata: {
                                name: persistent_name_val
                            },
                            spec: {
                                capacity: {
                                    storage: `${persistent_total_val}${persistent_total_unit}`
                                },
                                accessModes: [persistent_visit_val],
                                persistentVolumeReclaimPolicy: persistent_recycle_val,
                                ...(persistent_total_val === 'NFS' && {nfs: {...new_parameter, fsType: "ext4"}}),
                                ...(persistent_total_val === 'Ceph-rbd' && {rbd: {...new_parameter, fsType: "ext4"}})
                            }
                        };
                        // } else if(persistent_total_val === 'Ceph') {
                        //     persistent_body = {
                        //         metadata: {
                        //             name: persistent_name_val
                        //             },
                        //             spec: {
                        //             capacity: {
                        //                 storage: `${persistent_total_val}${persistent_total_unit}`
                        //             },
                        //             accessModes: [persistent_visit_val],
                        //                 persistentVolumeReclaimPolicy: persistent_recycle_val,
                        //                 rbd: {
                        //                     monitors: ["10.16.154.78:6789"],
                        //                     "pool": "kube",
                        //                     "image": "foo",
                        //                     "fsType": "ext4",
                        //                     "readOnly": true,
                        //                     "user": 'admin',
                        //                     "secretRef": {
                        //                     "name": "ceph-secret"
                        //                 }
                        //             }
                        //         }
                        //     }
                        // }
                        break;
                    case 'pvc':
                        persistent_url = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/namespace/${namespace_selected?.name}/pvc`;
                        switch (persistent_distribution_val) {
                            case 1: persistent_body = persistent_tabs_val === 'form-input'? {
                                metadata: {
                                    name: persistent_name_val
                                },
                                spec: {
                                    accessModes: [persistent_visit_val],
                                    storageClassName: storage_row_selected[0],
                                    resources: {
                                        requests: {
                                            storage: `${persistent_total_val}${persistent_total_unit}`
                                        }
                                    }
                                }
                            }: yaml_data;
                        }
                        break;
                    default:
                        break;
                }
                api_result = await worker_fetch({
                    url: persistent_url,
                    method: 1,
                    props: {history, formatMessage},
                    body: persistent_body,
                    datacenter_name
                });
            }
        }else if(persistent_action === 2){
            set_table_list_modal((currentState) => ({
                ...currentState,
                modal_ok_button: true
            }));
            let persistent_url: string = '';
            switch (list_type) {
                case 'pv':
                    persistent_url = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/pv/${table_list_modal?.pv_yaml_data?.metadata?.name}`;
                    break;
                case 'pvc':
                    persistent_url = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/namespace/${namespace_selected?.name}/pvc/${table_list_modal?.pv_yaml_data?.metadata?.name}`;
                    break;
                default: break;

            }
            api_result = await worker_fetch({
                url: persistent_url,
                method: 3,
                props: {history, formatMessage},
                datacenter_name
            });
        }
        if (api_result?.status >= 200 && api_result?.status < 300) {
            set_table_list_modal((currentState)=>({
                ...currentState,
                visible: false,
                pv_yaml_data: 'action_success'
            }));
            clean_form();
        } else {
            const {reason, message} = api_result?.data || {};
            notification.error({
                message: reason || api_result?.status,
                description: message
            })
        }
        set_table_list_modal((currentState) => ({
            ...currentState,
            modal_ok_button: false
        }));
        return;
    }
      if (user_info.role && !table_list_modal.is_logs && datacenter_name && !table_list_modal.is_initialization && !table_list_modal.is_scale_replica && !table_list_modal.is_edit_yaml && !table_list_modal.is_sure_edit && !table_list_modal.is_view_yaml && !table_list_modal.is_delete_pod && !table_list_modal.is_restartLogs) {
        let labels: labels = {},
          spec: spec = {};
        const quotas_new = {
          ...(gpu_new.length && {"requests.nvidia.com/gpu": gpu_new}),
          ...(cpu_new.length && { "limits.cpu": cpu_new, "requests.cpu": cpu_request_new.length ? cpu_request_new : cpu_new }),
          ...(memory_new.length && { "limits.memory": change_unit(memory_new, unit_provide, true).toString(), "requests.memory": change_unit(memory_request_new.length ? memory_request_new : memory_new, unit_provide, true).toString() }),
          ...(rootfs_new && { "limits.ephemeral-storage": change_unit(rootfs_new, unit_provide, true).toString(), "requests.ephemeral-storage": change_unit(rootfs_request_new || rootfs_new, unit_provide, true).toString() }),
          ...(pod_new && { pods: pod_new }),
          ...(pvc_new && { "requests.storage": change_unit(pvc_new, unit_provide, true).toString() }),
          ...(pv_new && { persistentvolumeclaims: pv_new }),
          ...(service_new && { services: service_new }),
          ...(secret_new && { secrets: secret_new }),
          ...(configmap_new && { configmaps: configmap_new }),
        };
        const wk_autoscale_new = {
          ...(type_name === 'shared' ? wk_auto_scale && { "type": "general" } : wk_auto_scale && { "type": "normal" }),
          ...(wk_timeout && wk_auto_scale && { "scaleindefer": wk_timeout }),
          ...(wk_auto_scale && { "autoscale": wk_auto_scale.toString() }),
          ...(wk_max_quota !== '' && wk_auto_scale && { "maxquota": wk_max_quota }),
          ...(wk_min_quota !== '' && wk_auto_scale && { "minquota": wk_min_quota }),
        }
        switch (list_type) {
          case "clusters":
            labels = { type: type_selected };
            spec = (config_new.users || [])[0]?.user["token"] ? {
              token: (config_new.users || [])[0]?.user["token"],
              host: (config_new.clusters || [])[0]?.cluster.server,
              cacert:  (config_new.clusters || [])[0]?.cluster["insecure-skip-tls-verify"] === true ? '' : (config_new.clusters || [])[0]?.cluster["certificate-authority-data"],
            } : {
              clientcert: {
                cert: (config_new.users || [])[0]?.user["client-certificate-data"],
                key: (config_new.users || [])[0]?.user["client-key-data"],
              },
              host: (config_new.clusters || [])[0]?.cluster.server,
              cacert:  (config_new.clusters || [])[0]?.cluster["insecure-skip-tls-verify"] === true ? '' : (config_new.clusters || [])[0]?.cluster["certificate-authority-data"],
            };
            break;

          case "workspaces":
            // const cpuNodeObj: any ={};
            // cpu_node_selected?.map((cpunode: string, index: number) => cpuNodeObj[`cpunode${index}`] = cpunode);
            // const gpuNodeObj: any ={};
            // gpu_node_selected?.map((gpunode: string, index: number) => gpuNodeObj[`gpunode${index}`] = gpunode);
            labels = {
              ...wk_autoscale_new,
              bindcpunodes: cpu_node_selected?.length>0? cpu_node_selected.join(','): '',
              bindgpunodes: gpu_node_selected?.length>0? gpu_node_selected.join(','): ''
              // ...cpuNodeObj,
              // ...gpuNodeObj,
            };
            spec = { workspacequota: wk_auto_scale ? wk_autoscale_workspaceQuota : table_list_modal.quota_selected };
            break;

          case "namespaces":
            labels = { workspace: workspace_selected?.name, namespacequota: table_list_modal.quota_selected };
            break;

          case "workspacequotas":
            spec.quotas = quotas_new;
            break;

          case "namespacequotas":
            const workspace_found = workspaces?.find((workspace) => workspace.metadata.labels.name === workspace_new);
            workspace_found && (labels.workspace = workspace_found.metadata.name);
            spec.quotas = quotas_new;
            break;

          case "scale":
            assign(table_list_modal.quota_selected);
            set_table_list_modal((currentState) => ({ ...currentState, visible: false, is_unassign_quota: false }));
            break;
        }

        table_list_modal.action === 0 &&
          has_local_user_subscription &&
          cluster_selected?.name &&
          (await http_request(
            "user_subscriptions",
            props,
            undefined,
            `/v4.0/subscriptions/${subscription_id_local}/users`,
            1,
            "globalAdmin",
            subscription_id_local,
            datacenter_name,
            cluster_selected?.name,
            { userName: username_login, subscriptionRole: "admin" },
            undefined,
            true,
            true
          ));

        const url: string = `/v1/datacenter/${datacenter_name}${
          list_type !== "clusters" ? `/cluster/${(cluster_selected || {}).name || ""}` : ""
          }/${list_type}`,
          item_selected_name: string = item_selected?.name || "",
          // 第一個：新建，第二個：修改，第三個：刪除
          actions: [
            string,
            number,
            string,
            string | undefined,
            string,
            string,
            object?,
            workspaces_type_item[]?,
            boolean?,
            boolean?,
            boolean?,
            string?,
            string?,
            string?,
            string?,
            string?,
            number?,
            boolean?,
            string?
          ][] = [
              [
                url.substr(0, url.length - 1),
                1,
                user_info.role,
                `${has_local_user_subscription ? subscription_id_local : user_info.subscription_id}&type=${type_name}`,
                datacenter_name,
                (cluster_selected || {}).name || "",
                Object.keys(labels).length > 0 ? { metadata: { name: name_new, labels }, spec } : { metadata: { name: name_new }, spec },
                undefined,
                list_type === "clusters" ? true : undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                list_type === "namespaces" || list_type === "namespacequotas" ? workspace_selected?.name : undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                user_info.subscription_id,
              ],
              [
                `${url.substr(0, url.length - 1)}/${item_selected_name}`,
                2,
                user_info.role,
                `${user_info.subscription_id}&type=${type_name}`,
                datacenter_name,
                (cluster_selected || {}).name || "",
                Object.keys(labels).length > 0 ? { metadata: { name: name_new, labels }, spec } : { metadata: { name: name_new ? name_new : list_type === "workspaces" && item_selected?.labels?.name }, spec },
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                list_type === "namespaces" || list_type === "namespacequotas" ? workspace_selected?.name : undefined,
              ],
              [
                `${url.substr(0, url.length - 1)}/${item_selected_name}`,
                3,
                user_info.role,
                `${user_info.subscription_id}&type=${type_name}`,
                datacenter_name,
                (cluster_selected || {}).name || "",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                list_type === "namespaces" || list_type === "namespacequotas" ? workspace_selected?.name : undefined,
              ],
            ];

        if (actions[table_list_modal.action]) {
          const http_response: response_type = (await http_request(list_type, props, set_functions[list_type], ...actions[table_list_modal.action])) as response_type;
          table_list_modal.action === 0 &&
            has_local_user_subscription &&
            cluster_selected?.name &&
            (await http_request(
              "subrole_binding",
              props,
              undefined,
              `/v1/datacenter/${datacenter_name}/subrolebinding`,
              1,
              "globalAdmin",
              subscription_id_local,
              datacenter_name,
              cluster_selected?.name,
              {
                role: list_type === "clusters" ? "cluster-owner" : "workspace-owner",
                datacenter: datacenter_name,
                cluster: list_type === "clusters" ? name_new : cluster_selected?.name,
                subscriptionId: subscription_id_local,
                ...(list_type === "workspaces" ? { workspace: ((http_response as unknown) as workspaces_type_item)?.metadata.name } : {}),
              },
              undefined,
              true,
              true
            ));
          const is_fresh_new = is_fresh;
          if (http_response && (!http_response.code || (http_response.code && http_response.code < 400))) {
            list_type === "clusters" && table_list_modal.action === 0 && has_local_user_subscription && (cluster_selected?.name || name_new) && set_is_fresh(!is_fresh_new);
            !!name_new && set_sort_first(name_new);
            set_name_validate({ status: "", msg: null });
            set_memory_validate({ status: "", msg: null });
            set_memory_request_validate({status: "", msg: null});
            set_gpu_validate({status: "", msg: null});
            set_cpu_validate({ status: "", msg: null });
            set_cpu_request_validate({status: "", msg: null});
            set_rootfs_validate({ status: "", msg: null });
            set_rootfs_request_validate({status: "", msg: null});
            set_pod_validate({ status: "", msg: null });
            set_pvc_validate({ status: "", msg: null });
            set_pv_validate({ status: "", msg: null });
            set_service_validate({ status: "", msg: null });
            set_configmap_validate({ status: "", msg: null });
            set_secret_validate({ status: "", msg: null });
            set_table_list_modal((currentState) => ({ ...currentState, visible: false, quota_selected: undefined }));
            set_gpu_new("");
            set_cpu_new("");
            set_cpu_request_new("");
            set_rootfs_new("");
            set_rootfs_request_new("");
            set_pod_new("");
            set_pvc_new("");
            set_pv_new("");
            set_service_new("");
            set_secret_new("");
            set_configmap_new("");
            set_wk_auto_scale(false);
            set_wk_auto_scale_false('');
            set_name_new("");
            set_wk_min_quota("500m2g-wq");
            set_wk_max_quota("8c32g-wq");
            set_wk_autoscale_workspaceQuota("");
            set_cpu_node_list([]);
            set_gpu_node_list([]);
            set_cpu_node_selected('');
            set_gpu_node_selected('');
          } else {
            set_table_list_modal((currentState) => ({ ...currentState, visible: false, quota_selected: undefined }));
            set_wk_auto_scale(false);
            set_wk_auto_scale_false('');
            set_name_new("");
            set_wk_min_quota("500m2g-wq");
            set_wk_max_quota("8c32g-wq");
            set_wk_autoscale_workspaceQuota("");
          }
        }
      } else if (user_info.role && datacenter_name && table_list_modal.is_initialization && cluster_selected?.name) {
        const cluster_init_new = {
          clusterName: cluster_selected?.name,
          datacenter: datacenter_name,
          sshUser: ssh_user_new,
          sshPrivateKey: pravite_key_new,
          ...(nginx_controller_checked && { nginxIngress: {} }),
          ...(cluster_agent_checked && image_version_new && {
            clusterAgent: {
              imageVersion: image_version_new
            }
          }),
          ...(log_slave_checked && ip_address_new && {
            logSlave: {
              masterIp: ip_address_new
            }
          }),
          ...(rms_checked && {
            rms: {
              requestStorage: request_storage_new,
              isSupportHttps: support_https_checked.toString(),
            }
          }),
        };
        const cluster_init_response: response_type = (await http_request('cluster_init', props, undefined, `/mpBuy/config/deploy`, 1, user_info.role, undefined, datacenter_name, cluster_selected?.name, cluster_init_new, undefined,
          true, undefined)) as response_type;
        if (cluster_init_response && (!cluster_init_response.status || (cluster_init_response.status && cluster_init_response.status < 400))) {
          set_ssh_user_new("");
          set_pravite_key_new("");
          set_nginx_controller_checked(true);
          set_cluster_agent_checked(true);
          set_image_version_new("");
          set_log_slave_checked(true);
          set_ip_address_new("");
          set_rms_checked(true);
          set_support_https_checked(true);
          set_table_list_modal((currentState) => ({ ...currentState, visible: false, is_initialization: false }));
        }
      } else if (user_info.role && datacenter_name && table_list_modal.is_scale_replica) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && scale_replica.type !== '' && scale_replica.scale !== '' && scale_replica.name !== '') {
          const change_replica: any = await http_request('change_replica', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/${scale_replica.type?.toLocaleLowerCase() === 'deployment' ? 'deployment' : scale_replica.type?.toLocaleLowerCase() === 'statefulset' && 'statefulset'}/${scale_replica.name}/replica/${scale_replica.scale}`, 2, user_info.role, undefined, datacenter_name, cluster_selected_name);
          change_replica && set_refresh_workloads({ name: scale_replica.name, type: scale_replica.type, scale_replica: scale_replica.scale });
          set_table_list_modal((currentState) => ({ ...currentState, visible: false, is_scale_replica: false }));
        } else {
          set_refresh_workloads(undefined);
        }
      } else if (user_info.role && datacenter_name && table_list_modal.is_sure_edit) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && wk_edit_yaml_new.type !== '' && wk_edit_yaml_new.name !== '' && wk_edit_yaml_new.content) {
          const workload_edit_yaml: any = await http_request('workload_edit_yaml', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/${wk_edit_yaml_new.type?.toLocaleLowerCase()}/${wk_edit_yaml_new.name}`, 2, user_info.role, undefined, datacenter_name, cluster_selected_name, yaml.load(wk_edit_yaml_new.content), undefined, true, false);
          workload_edit_yaml && set_refresh_workloads({ workload_yaml: yaml.load(wk_edit_yaml_new.content) });
          set_table_list_modal((currentState) => ({ ...currentState, visible: false, is_sure_edit: false }));
        }
      } else if (user_info.role && datacenter_name && table_list_modal.is_delete_pod) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && item_selected?.name) {
          const pod_delete: any = await http_request('pod_delete', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${item_selected?.name}`, 3, user_info.role, undefined, datacenter_name, cluster_selected_name, undefined, undefined, true, false);
          pod_delete && set_refresh_workloads({ delete_pod: item_selected?.name });
          set_table_list_modal((currentState) => ({ ...currentState, visible: false, is_delete_pod: false }));
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      table_list_modal.action,
      assign,
      cluster_selected,
      configmap_new,
      gpu_new,
      cpu_new,
      item_selected,
      list_type,
      memory_new,
      name_new,
      pod_new,
      pv_new,
      pvc_new,
      table_list_modal.quota_selected,
      user_info.role,
      rootfs_new,
      secret_new,
      service_new,
      set_functions,
      user_info.subscription_id,
      unit_provide,
      workspace_new,
      workspace_selected,
      workspaces,
      table_list_modal.is_logs,
      datacenter_name,
      has_local_user_subscription,
      subscription_id_local,
      username_login,
      type_name,
      type_selected,
      config_new,
      set_table_list_modal,
      set_sort_first,
      table_list_modal.is_initialization,
      ssh_user_new,
      pravite_key_new,
      nginx_controller_checked,
      cluster_agent_checked,
      image_version_new,
      log_slave_checked,
      ip_address_new,
      rms_checked,
      request_storage_new,
      support_https_checked,
      table_list_modal.is_scale_replica,
      scale_replica,
      namespace_selected,
      set_refresh_workloads,
      table_list_modal.is_sure_edit,
      wk_edit_yaml_new,
      table_list_modal.is_view_yaml,
      table_list_modal.is_delete_pod,
      wk_auto_scale,
      wk_timeout,
      wk_min_quota,
      wk_max_quota,
      wk_autoscale_workspaceQuota,
      table_list_modal.is_restartLogs,
      persistent_recycle_val,
      persistent_visit_val,
      persistent_parameter_val,
      persistent_type_val,
      persistent_bind_val,
      persistent_name_val,
      persistent_total_val,
      persistent_tabs_val,
      persistent_yaml_edit_val,
      cpu_node_selected,
      gpu_node_selected
    ]),
    // 詢問視窗按取消
    handle_cancel: () => void = useCallback((): void => {
      switch (true) {
        case table_list_modal.is_logs:
          set_table_list_modal((currentState) => ({ ...currentState, is_logs: false }));
          set_logs(undefined);
          set_containers(undefined);
          set_containerName_selected(undefined);
          break;
        case table_list_modal.is_config:
          set_table_list_modal((currentState) => ({ ...currentState, is_config: false }));
          set_config_string(undefined);
          break;
        case table_list_modal.is_details:
          set_table_list_modal((currentState) => ({ ...currentState, is_details: false }));
          set_ingress_event(undefined);
          break;
        case table_list_modal.is_yaml:
          set_table_list_modal((currentState) => ({ ...currentState, is_yaml: false }));
          set_ingress_new(undefined);
          break;
        case table_list_modal.is_web_kubectl:
          set_table_list_modal((currentState) => ({ ...currentState, is_web_kubectl: false }));
          break;
        case table_list_modal.is_initialization:
          set_table_list_modal((currentState) => ({ ...currentState, is_initialization: false }));
          break;
        case table_list_modal.is_scale_replica:
          set_table_list_modal((currentState) => ({ ...currentState, is_scale_replica: false }));
          break;
        case table_list_modal.is_sure_edit:
          set_table_list_modal((currentState) => ({ ...currentState, is_sure_edit: false, is_edit_yaml: false }));
          break;
        case table_list_modal.is_edit_yaml:
          set_table_list_modal((currentState) => ({ ...currentState, is_sure_edit: false, is_edit_yaml: false }));
          break;
        case table_list_modal.is_view_yaml:
          set_table_list_modal((currentState) => ({ ...currentState, is_view_yaml: false, origin: undefined }));
          // set_edit_yaml_disabled(true);
          break;
        case table_list_modal.is_delete_pod:
          set_table_list_modal((currentState) => ({ ...currentState, is_delete_pod: false }));
          break;
        case table_list_modal.is_unassign_quota:
          set_table_list_modal((currentState) => ({ ...currentState, is_unassign_quota: false }));
          break;
        case table_list_modal.is_restartLogs:
          set_table_list_modal((currentState) => ({ ...currentState, is_restartLogs: false }));
          break;
        default:
          set_name_validate({ status: "", msg: null });
          set_gpu_validate({status: "", msg: null});
          set_cpu_validate({ status: "", msg: null });
          set_cpu_request_validate({status: "", msg: null});
          set_memory_validate({status: "", msg: null});
          set_memory_request_validate({status: "", msg: null});
          set_rootfs_validate({ status: "", msg: null });
          set_rootfs_request_validate({status: "", msg: null});
          set_pod_validate({ status: "", msg: null });
          set_pvc_validate({ status: "", msg: null });
          set_pv_validate({ status: "", msg: null });
          set_service_validate({ status: "", msg: null });
          set_configmap_validate({ status: "", msg: null });
          set_secret_validate({ status: "", msg: null });
          set_gpu_new("");
          set_cpu_new("");
          set_cpu_request_new("");
          set_rootfs_new("");
          set_rootfs_request_new("");
          set_pod_new("");
          set_pvc_new("");
          set_pv_new("");
          set_service_new("");
          set_secret_new("");
          set_configmap_new("");
          set_wk_auto_scale(false);
          set_wk_auto_scale_false('');
          set_name_new("");
          set_wk_min_quota("500m2g-wq");
          set_wk_max_quota("8c32g-wq");
          set_wk_autoscale_workspaceQuota("");
          set_wk_auto_scale_disabled(false);
          set_cpu_node_list([]);
          set_gpu_node_list([]);
          set_cpu_node_selected('');
          set_gpu_node_selected('');
          break;
      }
      set_table_list_modal((currentState) => ({
        ...currentState,
        visible: false,
        ...(!table_list_modal.is_logs && !table_list_modal.is_logs
          ? {
            modal_message: undefined,
            modal_title: "",
            action: 0,
            ...(table_list_modal.quota_selected === item_selected.quotaName && path.includes("workspace/scale") ? { modal_ok_button: false } : {}),
            quota_selected: undefined
          }
          : {}),
      }));
    }, [
      item_selected.quotaName,
      path,
      table_list_modal.quota_selected,
      table_list_modal.is_logs,
      set_table_list_modal,
      table_list_modal.is_config,
      table_list_modal.is_details,
      table_list_modal.is_yaml,
      table_list_modal.is_web_kubectl,
      table_list_modal.is_initialization,
      table_list_modal.is_scale_replica,
      table_list_modal.is_edit_yaml,
      table_list_modal.is_sure_edit,
      table_list_modal.is_view_yaml,
      table_list_modal.is_delete_pod,
      table_list_modal.is_unassign_quota,
      table_list_modal.is_restartLogs
    ]),
    sure_edit_yaml = useCallback(() => {
      // set_edit_yaml_disabled(true);
      set_table_list_modal((currentState) => ({
        ...currentState,
        visible: true,
        modal_title: `${formatMessage({ id: "edit" })} ${item_selected.name}`,
        modal_message: (
          <p>
            <FormattedMessage id="edit_desc" />
          </p>
        ) /*你确定要编辑吗?*/,
        // modal_ok_button: false,
        is_sure_edit: true,
        is_edit_yaml: false,
        is_view_yaml: false,
        origin: 'workload',
      }));
    }, [item_selected.name, set_table_list_modal, formatMessage]),
    config_header: JSX.Element[] = useMemo((): JSX.Element[] => {
      const { config }: loading_type = loading;
      return [
        <Text copyable={{ text: config_string }} className="ant-btn" />,
        <Button
          key="2"
          className="ml-10"
          onClick={() => {
            set_loading({ config: true });
          }}
        >
          {config ? <LoadingOutlined spin /> : <SyncOutlined />}
        </Button>,
        <Button
          key="3"
          className="ml-10"
          onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => {
            download_config(event);
          }}
        >
          <DownloadOutlined />
        </Button>,
      ];
    }, [loading, download_config, config_string]),
    subscriptionKey = useCallback((key: string, units: string) => {
      switch (key) {
        case "limits.cpu":
          return ` (Core)`;
        case "limitCPU":
          return ` (Core)`;
        case "limits.memory":
          return ` (${units})`;
        case "limitMemory":
          return ` (${units})`;
        case "limits.rootfs":
          return ` (${units})`;
        case "limitsRootfs":
          return ` (${units})`;
        case "limits.disk":
          return ` (${units})`;
        case "limitsDisk":
          return ` (${units})`;
        default:
          return "";
      }
    }, []),
    subscriptionValue = useCallback((key: string, val: any, units: string) => {
      const calculate = (num: any) => {
        switch (units) {
          // case 'Mi': return Number(num);
          case "Gi":
            return (Number(num) / 1024).toFixed(2);
          case "Ti":
            return (Number(num) / 1024 / 1024).toFixed(2);
          case "Pi":
            return (Number(num) / 1024 / 1024).toFixed(2);
          default:
            return num;
        }
      };
      switch (key) {
        case "limits.memory":
          return calculate(val);
        case "limitMemory":
          return calculate(val);
        case "limits.rootfs":
          return calculate(val);
        case "limitsRootfs":
          return calculate(val);
        case "limits.disk":
          return calculate(val);
        case "limitsDisk":
          return calculate(val);
        default:
          return val;
      }
    }, []);

  useEffect(()=>{
    if(item_selected?.labels?.name && path.includes("cluster-info/workspaces") && table_list_modal.action === 1 && table_list_modal.visible){
      set_name_new(item_selected?.labels?.name)
    }
  }, [item_selected?.labels?.name, path, table_list_modal.action, table_list_modal.visible])

  useEffect((): void => {
    set_memory_new(options && options[0]);
  }, [options]);

  useEffect((): void => {
    set_workspace_new(workspace_selected?.labels?.name || ((((workspaces || [])[0] || {}).metadata || {}).labels || {}).name || "");
  }, [workspace_selected, workspaces]);

  useEffect((): void => {
    const values = ["2", "4", "6", "8", "10", "12", "14", "16", "18", "20", "22", "24", "26", "28", "30", "32"];
    switch (unit_provide) {
      case "Gi":
        set_options(values);
        break;
      case "Mi":
        set_options(values.map((v) => (Number(v) * 1024).toString()));
        break;
      case "Ti":
        set_options(values.map((v) => (Number(v) / 1024).toFixed(2).toString()));
        break;
      case "Pi":
        set_options(values.map((v) => (Number(v) / (1024 * 1024)).toFixed(2).toString()));
        break;
    }
  }, [unit_provide]);

  useEffect((): void => {
    const is_edit = table_list_modal.action === 1 && !table_list_modal.is_yaml;
    if(path.includes("workspaces")) {
      is_edit && item_selected && item_selected?.quotaName ? set_worksapce_default_quota(item_selected?.quotaName) : set_worksapce_default_quota(quotas && quotas[0] && quotas[0].metadata.name);
      is_edit && item_selected && item_selected?.quotaName && set_table_list_modal((currentState) => ({ ...currentState, quota_selected: item_selected?.quotaName }));
    } else if (path.includes("namespaces")) {
      is_edit && item_selected && item_selected?.quotaName ? set_namespace_default_quota(item_selected?.quotaName) : set_namespace_default_quota("");
      is_edit && item_selected && item_selected?.quotaName && set_table_list_modal((currentState) => ({ ...currentState, quota_selected: item_selected?.quotaName }));
    }
  },[path, quotas, table_list_modal.action, table_list_modal.is_yaml, item_selected, set_worksapce_default_quota, set_namespace_default_quota, set_table_list_modal, table_list_modal.visible]);

  const is_not_workload: boolean = useMemo((): boolean => !(path.includes("workloads")), [path]);

  useEffect((): void => {
    // const is_edit = table_list_modal.action === 1 && !table_list_modal.is_yaml;
    const assign_form: JSX.Element | undefined = ((): JSX.Element | undefined => {
      if (path.includes("quota")) {
        if (path.includes("name") && workspaces) {
          if (!assign_item_selected?.length && workspaces[0]) set_assign_item_selected(workspaces[0].metadata.name);
          return (
            <Form.Item>
              <Col sm={10}>Workspace</Col>
              <Col sm={14}>
                <Select
                  defaultValue={workspaces[0] && workspaces[0].metadata.name}
                  onChange={(event: string) => {
                    set_assign_item_selected(event);
                  }}
                >
                  {Array.isArray(workspaces) &&
                    workspaces.map((item) => (
                      <Option value={item.metadata.name} key={item.metadata.name}>
                        {item.metadata.name}
                      </Option>
                    ))}
                </Select>
              </Col>
            </Form.Item>
          );
        }
      } else {
        return (
          <Form.Item
            key="quotas"
            className={`${path === "workspace-info/namespaces" ? "quotas-select" : ""}`}
            label={ path.includes('workspaces') ? <FormattedMessage id="workspaceQuota" /> : path.includes('namespaces') ? <FormattedMessage id="namespaceQuota" /> : <FormattedMessage id="quota" />  }
            labelCol={{ sm: 5 }}
            wrapperCol={{ sm: 14, offset: 5 }}
            required={path !== "workspace-info/namespaces" && !(path.includes("quota")) && is_not_workload && !path.includes("clusters") && !!permission[4]}
          >
            <Col>
              <Select
                showSearch
                optionFilterProp="children"
                value={path.includes("workspaces") ? worksapce_default_quota : namespace_default_quota}
                disabled={(!(path.includes("quota")) && is_not_workload && !path.includes("clusters") && !!permission[4]) || path === "workspace-info/namespaces" ? false : true}
                onChange={(event: string) => {
                  // path.includes("workspaces") && is_edit && item_selected && item_selected?.quotaName && event !== item_selected?.quotaName ? set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true })) : set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false }));
                  path.includes("workspaces") && set_worksapce_default_quota(event);
                  path.includes("namespaces") && set_namespace_default_quota(event);
                  set_table_list_modal((currentState) => ({ ...currentState, quota_selected: event }));
                }}
              >
                {path === "workspace-info/namespaces" && (
                  <Option key="--Without Quota--" value="">
                    <FormattedMessage id="--without_quota--" />
                  </Option>
                )}
                {Array.isArray(quotas) &&
                  quotas.map((quota) => (
                    <Option value={quota.metadata.name} key={quota.metadata.name}>
                      {quota.metadata.name}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Form.Item>
        );
      }
      return undefined;
    })();

    assign_form && set_assign_list(assign_form);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assign_item_selected, path, quotas, workspaces, worksapce_default_quota, namespace_default_quota]);

  useEffect((): void => {
    list_type === "workspacequotas" &&
      (quotas || [])[0] &&
      quotas[0].spec &&
      set_quota_info_list(
        <Descriptions size="small" column={1} bordered>
          {quotas[0].spec.quotas &&
            Object.keys(quotas[0].spec.quotas).map((key: string) => (
              <Descriptions.Item className="w-120 text-ellipsis w-max-100" label={key + subscriptionKey(key, unit_provide)} key={key}>
                {subscriptionValue(key, (quotas[0].spec.quotas as key_value)[key], unit_provide)}
              </Descriptions.Item>
            ))}
        </Descriptions>
      );
  }, [quotas, unit_provide, list_type, subscriptionKey, subscriptionValue]);

  useEffect((): void => {
    const workspace_input_new: JSX.Element = (
      <Form.Item labelCol={{ sm: 10 }} wrapperCol={{ sm: 14 }} label="Workspace" required={true}>
        {workspace_select[1]}
      </Form.Item>
    );
    set_workspace_input(workspace_input_new);
  }, [workspace_select, set_workspace_input]);

  useEffect((): void => {
    if(table_list_modal.visible && !table_list_modal.quota_selected && quotas) {
      path === "workspace-info/namespaces" ? 
      set_table_list_modal((currentState) => ({ ...currentState, quota_selected: '' })) :
      set_table_list_modal((currentState) => ({ ...currentState, quota_selected: quotas[0]?.metadata?.name }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[table_list_modal.visible, table_list_modal.action, table_list_modal.quota_selected, quotas, path])

  useEffect((): void => {
    const quota_selected_new: quota_type_item | undefined = Array.isArray(quotas)
      ? quotas.find((quota: quota_type_item) => table_list_modal.quota_selected === quota.metadata?.name)
      : undefined;
    set_quota_info_list(
      quota_selected_new ? (
        <Descriptions size="small" column={2} bordered>
          {quota_selected_new.spec.quotas &&
            Object.keys(quota_selected_new.spec.quotas).map((key: string, index: number) => (
              <Descriptions.Item className="w-120 text-ellipsis w-max-100" label={`${key === 'configmaps' ? 'configmaps' : key === 'persistentvolumeclaims' ? 'PVC' : key === 'limitCPU' ? 'limitsCPU' : key === 'limitMemory' ? 'limitsMemory' : key}` + subscriptionKey(key, unit_provide)} key={key+index}>
                {subscriptionValue(key, (quota_selected_new.spec.quotas as key_value)[key], unit_provide)}
              </Descriptions.Item>
            ))}
        </Descriptions>
      ) : (
          <Fragment key="0"></Fragment>
        )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotas, unit_provide, table_list_modal.quota_selected, item_selected]);

  useEffect((): void => {
    if (
      table_list_modal.action === 0 &&
      table_list_modal.visible &&
      !table_list_modal.is_initialization &&
      ((path.includes("workspaces") && has_local_user_subscription) || path.includes("clusters"))
    ) {
      (async () => {
        const user_subscriptions_new = ((await http_request(
          "user_subscriptions",
          props,
          set_user_subscriptions,
          `/v4.0/subscriptions`,
          0,
          "globalAdmin",
          undefined,
          "",
          ""
        )) as response_type)?.items as user_subscription_all[];
        set_subscription_id_local(
          user_subscriptions_new?.find(({ id }: user_subscription_all) => id === subscription_id_local)
            ? subscription_id_local
            : (user_subscriptions_new || [])[0]?.id
        );
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps              
  }, [table_list_modal.action, table_list_modal.visible, table_list_modal.is_initialization, set_user_subscriptions, has_local_user_subscription, subscription_id_local, path]);

  useEffect((): void => {
    const validate_m = (funcs: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>], event: string, message: string) => {
      const value = event,
        pattern = new RegExp(/^[0-9]+$/);
      const valid: boolean = pattern.test(value);
      if (value.length) {
        funcs[0](!valid ? { status: "error", msg: `Only ${message} allowed` } : { status: "success", msg: null });
        funcs[1](value);
      } else {
        funcs[0]({ status: "", msg: null });
        funcs[1](value);
      }
    };

    function validate_number_m(this: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>], event: string) {
      validate_m(this, event, "0-9 Digital");
    }

    const validate_1 = (
      funcs: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
      event: string
  ) => {
      if (event?.length <= 0) {
          funcs[0]({status: "error", msg: formatMessage({id: "this_field_is_required"})});
          funcs[1](event)
      } else {
          funcs[0]({status: "", msg: null});
          validate_m(funcs, event, "0-9 Digital")
      }
  };

  function validate_required(
      this: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
      event: string
  ) {
      path.includes("workspace-quotas") ? validate_1(this, event) : validate_m(this, event, "0-9 Digital")
  }

    const memory_input_new: JSX.Element = (
      <Form.Item
        labelCol={{ sm: 10 }}
        wrapperCol={{ sm: 14 }}
        label={`${formatMessage({ id: "memory" })} Limit(${unit_provide})`}
        hasFeedback
        className="validate_icon"
        validateStatus={memory_validate.status}
        help={memory_validate.msg}
        required={path.includes("workspace-quotas")}
      >
        {cluster_selected?.labels?.type === "shared" ? (
          <Select defaultValue={options[0]} onChange={(e: any) => set_memory_new(e)}>
            {options.map((o) => (
              <Option value={o} key={o}>
                {o}
              </Option>
            ))}
          </Select>
        ) : (
            cluster_selected?.labels?.type === "dedicate" && (
              <AutoComplete
                defaultValue={options[0]}
                options={options.map((item) => {
                  return { value: item };
                })}
                onChange={validate_required.bind([set_memory_validate, set_memory_new])}
              />
            )
          )}
      </Form.Item>
    );
    set_memory_input(memory_input_new);

    const memory_request_input_new: JSX.Element = (
      <Form.Item
          labelCol={{sm: 10}}
          wrapperCol={{sm: 14}}
          label={`${formatMessage({id: "memory"})} Request(${unit_provide})`}
          hasFeedback
          className="validate_icon"
      >
          {cluster_selected?.labels?.type === "shared" ? (
              <Select defaultValue={options[0]} onChange={(e: any) => set_memory_request_new(e)}>
                  {options.map((o) => (
                      <Option value={o} key={o}>
                          {o}
                      </Option>
                  ))}
              </Select>
          ) : (
              cluster_selected?.labels?.type === "dedicate" && (
                  <AutoComplete
                      defaultValue={options[0]}
                      options={options.map((item) => {
                          return {value: item};
                      })}
                      onChange={validate_number_m.bind([set_memory_request_validate, set_memory_request_new])}
                  />
              )
          )}
      </Form.Item>
  );
  set_memory_request_input(memory_request_input_new);
  }, [options, unit_provide, formatMessage, cluster_selected, memory_validate, memory_request_validate, path]);

  useEffect((): void => {
    set_podName_selected(undefined);
    set_containerName_selected(undefined);
  }, [item_selected])

  useEffect((): void => {
    if ((path.includes('workloads') || path.includes('applications-detail')) && !path.includes("restart-alarm") && table_list_modal.is_logs && table_list_modal.visible) {
      set_table_list_modal((currentState) => ({ ...currentState, modal_title: pod_dropdown }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pod_dropdown, set_table_list_modal, table_list_modal.visible, table_list_modal.is_logs, path])

  useEffect((): void => {
    (async () => {
      if (table_list_modal.is_logs) {
        const podNamesList: string[] = [];
        if (item_selected?.podNames) {
          item_selected.podNames.map((item: string) => {
            return podNamesList.push(item)
          })
        }
        if (item_selected?.unhealthyPodNames) {
          item_selected?.unhealthyPodNames.map((item: string) => {
            return podNamesList.push(item)
          })
        }
        const {clusterName, namespaceName} = table_list_modal.logs_data || {};
        const cluster_selected_name: string | undefined = path.includes('applications-detail') ? clusterName : cluster_selected?.name,
          namespace_selected_name: string | undefined = path.includes('applications-detail')? namespaceName : namespace_selected?.name,
          pod_name: string | undefined = podName_selected || (podNamesList || [])[0];
        // container_name: string | undefined = container_selected || (pod_selected?.containers || [])[0].name;
        if (
          cluster_selected_name &&
          namespace_selected_name &&
          pod_name &&
          datacenter_name
        ) {
          const content: any = ((await http_request('pod_item', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${pod_name}`, 0, user_info.role, undefined, datacenter_name, cluster_selected_name)) as unknown as any)?.Content;
          if (content && content?.spec?.containers) {
            set_containers(content.spec.containers);
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    podName_selected,
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    item_selected,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.is_logs,
  ]);

  useEffect((): void => {
    (async () => {
      if (table_list_modal.is_logs && table_list_modal.visible) {
        const {clusterName, namespaceName} = table_list_modal.logs_data || {};
        const cluster_selected_name: string | undefined = path.includes('applications-detail') ? clusterName : cluster_selected?.name,
          namespace_selected_name: string | undefined = path.includes('applications-detail')? namespaceName : namespace_selected?.name,
          pod_name: string | undefined = podName_selected || (item_selected?.podNames || item_selected?.unhealthyPodNames || [])[0],
          container_name: string | undefined = containerName_selected && containers?.filter((item: any) => item.name === containerName_selected) && containers?.filter((item: any) => item.name === containerName_selected)?.length > 0 ? containerName_selected : (containers || [])[0]?.name;
        if (
          cluster_selected_name &&
          namespace_selected_name &&
          pod_name &&
          (loading.logs || logs === undefined) &&
          datacenter_name &&
          container_name
        ) {
          set_logs(undefined);
          const logs_new: string =
            ((await http_request(
              "logs",
              props,
              undefined,
              `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${pod_name}/container/${container_name}/logs`,
              0,
              user_info.role,
              `${user_info.subscription_id}&lines=100`,
              datacenter_name,
              cluster_selected_name
            )) as logs | undefined)?.logs || "";
          set_logs(logs_new);
          set_loading({ logs: false });
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    podName_selected,
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    item_selected,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.is_logs,
    table_list_modal.visible,
    containerName_selected,
    containers,
    loading.logs,
    logs,
  ]);

  useEffect((): void => {
    (async () => {
      if (table_list_modal.is_details) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name,
          ingress_selected_name: string | undefined = item_selected?.name || sessionStorage.getItem("ingress") || undefined;
        if (
          cluster_selected_name &&
          namespace_selected_name &&
          ingress_selected_name &&
          table_list_modal.visible &&
          ingress_event === undefined &&
          datacenter_name
        ) {
          set_ingress_event(undefined);
          const event_init: any =
            (await http_request(
              "ingress_event",
              props,
              undefined,
              `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/event?resource=Ingress&resourcename=${ingress_selected_name}`,
              0,
              user_info.role,
              undefined,
              datacenter_name,
              cluster_selected_name
            )) || undefined,
            event_new: event_type_item[] = event_init && event_init.items && ((event_init.items as unknown) as event_type_item[]);
          const events: event_type_item[] = [];
          event_new &&
            event_new.map((event: event_type_item) => {
              return events.push(Object.assign({}, event, { object: "Ingress/" + ingress_selected_name }));
            });
          set_ingress_event(events);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.visible,
    table_list_modal.is_details,
    ingress_event,
  ]);

  useEffect((): void => {
    (async () => {
      if (table_list_modal.is_yaml && path.includes("ingress")) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name,
          ingress_selected_name: string | undefined = item_selected?.name || sessionStorage.getItem("ingress") || undefined;
        if (
          cluster_selected_name &&
          namespace_selected_name &&
          ingress_selected_name &&
          table_list_modal.visible &&
          (loading.yaml_ingress || ingress_new === undefined) &&
          datacenter_name
        ) {
          set_ingress_new(undefined);
          const yaml_new: any =
            (await http_request(
              "ingress_seleted",
              props,
              undefined,
              `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/router/${ingress_selected_name}`,
              0,
              user_info.role,
              undefined,
              datacenter_name,
              cluster_selected_name
            )) || undefined;
          set_ingress_new((yaml_new?.Content as unknown) as ingress_type_item);
          set_loading({});
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.visible,
    table_list_modal.is_yaml,
    loading.yaml_ingress,
    ingress_new,
  ]);

  useEffect((): void => {
    (async () => {
      if (table_list_modal.is_config) {
        set_table_list_modal((currentState) => ({ ...currentState, modal_title: config_header }));
        const cluster_selected_name: string | undefined = cluster_selected?.name;
        if (cluster_selected_name && (loading.config || config_string === undefined)) {
          set_config_string(undefined);
          datacenter_name &&
            cluster_selected?.name &&
            set_config_string(
              ((await http_request(
                "config",
                props,
                undefined,
                `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/config`,
                0,
                user_info.role,
                user_info.subscription_id,
                datacenter_name,
                cluster_selected_name
              )) as { config?: string })?.config || ""
            );
          set_loading({});
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.visible,
    config_header,
    table_list_modal.is_config,
    config_string,
    loading.config,
    set_table_list_modal,
  ]);

  // workload edit yaml api
  useEffect((): void => {
    (async () => {
      if (path.includes('workloads') && table_list_modal.visible && table_list_modal.origin === 'workload' && (table_list_modal.is_edit_yaml || table_list_modal.is_view_yaml)) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name &&
          namespace_selected_name && datacenter_name) {
          const wk_edit_yaml_res: any = await http_request('workload_yaml', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/${item_selected?.type?.toLocaleLowerCase()}/${item_selected?.name}`, 0, user_info.role, undefined, datacenter_name, cluster_selected_name);
          wk_edit_yaml_res && wk_edit_yaml_res.Content && set_wk_edit_yaml_data(wk_edit_yaml_res.Content);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.visible,
    table_list_modal.is_edit_yaml,
    set_wk_edit_yaml_data,
    table_list_modal.is_view_yaml,
    table_list_modal.origin
  ]);

  // workload pod view yaml api
  useEffect((): void => {
    (async () => {
      if (path.includes('workloads') && table_list_modal.visible && table_list_modal.origin === 'pod' && table_list_modal.is_view_yaml) {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
          namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name &&
          namespace_selected_name && datacenter_name) {
          const pod_view_yaml_res: any = await http_request('pod_yaml', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/pod/${item_selected?.name}`, 0, user_info.role, undefined, datacenter_name, cluster_selected_name);
          pod_view_yaml_res && pod_view_yaml_res.Content && set_wk_edit_yaml_data(pod_view_yaml_res.Content);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datacenter_name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cluster_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    item_selected?.name,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    user_info.role,
    user_info.subscription_id,
    table_list_modal.visible,
    set_wk_edit_yaml_data,
    table_list_modal.is_view_yaml,
    table_list_modal.origin
  ]);

  useEffect((): void => {
    if (table_list_modal.is_restartLogs && table_list_modal.visible) {
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <Row gutter={20} className="mb-10">
            <Col className="ant-col-sm-12">
              <div className="text-center mb-10"><FormattedMessage id="before_restart" /></div>
              {
                item_selected?.restartLog?.prelog?.length ?
                <TextArea className="restart_logs" value={JSON.parse(item_selected?.restartLog?.prelog)} readOnly />
              : 
              <Empty></Empty>
                }
            </Col>
            <Col className="ant-col-sm-12">
              <div className="text-center mb-10"><FormattedMessage id="after_restart" /></div>
              {item_selected?.restartLog?.afterlog?.length ?
                <TextArea className="restart_logs" value={JSON.parse(item_selected?.restartLog?.afterlog)} readOnly />
              : 
              <Empty></Empty>}
            </Col>
          </Row>         
        ),
      }));
    }
    // eslint-disable-next-line
  },[item_selected?.name, table_list_modal.is_restartLogs, table_list_modal.visible, formatMessage])

  useEffect((): void => {
    (table_list_modal.is_logs || table_list_modal.is_config) &&
      table_list_modal.visible &&
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <Form.Item className="ant-col-sm-24">
            {(table_list_modal.is_logs && logs?.length) || (table_list_modal.is_config && config_string?.length) ? (
              <TextArea className="logs" value={table_list_modal.is_logs ? logs : config_string} readOnly />
            ) : (
                <Empty></Empty>
              )}
          </Form.Item>
        ),
      }));
  }, [logs, config_string, table_list_modal.is_logs, table_list_modal.is_config, table_list_modal.visible, set_table_list_modal]);

  useEffect((): void => {
    if (table_list_modal.is_web_kubectl &&
      table_list_modal.visible) {
      const { domain }: Document = document;
      const mp_api_session = sessionStorage.getItem("mp_api") || `https://api-mp-ensaas${domain.substr(domain.indexOf('.'))}/v1`;
      path.includes("applications") && (table_list_modal.kubectl_app_cluster && table_list_modal.kubectl_app_namespace) ?
        set_table_list_modal((currentState) => ({
          ...currentState,
          modal_message: (
            <iframe
              title="terminal"
              style={{backgroundColor: '#000'}}
              src={(env && env["api-mp"]?.externalUrl ? `${env["api-mp"].externalUrl.substr(0, env["api-mp"].externalUrl.length - 2)}?clusterName=${table_list_modal.kubectl_app_cluster}&namespace=${table_list_modal.kubectl_app_namespace}` : `${mp_api_session.substr(0, mp_api_session.length - 2)}?clusterName=${table_list_modal.kubectl_app_cluster}&namespace=${table_list_modal.kubectl_app_namespace}`)
              }
            />
          ),
        })) :
        cluster_selected?.name && set_table_list_modal((currentState) => ({
          ...currentState,
          modal_message: (
            <iframe
              title="terminal"
              style={{backgroundColor: '#000'}}
              src={(env && env["api-mp"]?.externalUrl ? `${env["api-mp"].externalUrl.substr(0, env["api-mp"].externalUrl.length - 2)}?clusterName=${cluster_selected.name}` : `${mp_api_session.substr(0, mp_api_session.length - 2)}?clusterName=${cluster_selected.name}`)
              }
            />
          ),
        }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected, env, set_table_list_modal, table_list_modal.is_web_kubectl, table_list_modal.visible, path, table_list_modal.kubectl_app_cluster, table_list_modal.kubectl_app_namespace]);

  // ingress 的detalis modal
  useEffect((): void => {
    // rules table
    const rules = item_selected?.rules;
    const table_dataSource: rule_type_item[] = [];
    rules &&
      rules.map((rule_each: rule_type_item, index: number) => {
        return table_dataSource.push(Object.assign({}, rule_each, { key: "rule" + index }));
      });
    const table_title = ["host", "path", "serviceName", "servicePort"];
    const table_columns = table_title.map((each_title) => ({
      title: `${
        each_title === "host"
          ? "Domain"
          : each_title === "path"
            ? "Path"
            : each_title === "serviceName"
              ? "Name"
              : each_title === "servicePort"
                ? "Service Port"
                : ""
        }`,
      dataIndex: `${each_title === "host" ? each_title : "http"}`,
      key: each_title,
      render: (item: any) => {
        let children: JSX.Element | string;
        switch (each_title) {
          case "host":
            children = <Text>{item}</Text>;
            break;

          case "path":
            children = Array.isArray(item.paths) && item.paths.map((path: any, index: number) => <div key={path.path + index}>{path.path}</div>);
            break;

          case "serviceName":
            children =
              Array.isArray(item.paths) &&
              item.paths.map((path: any, index: number) => <div key={`${path.backend.serviceName ? path.backend.serviceName : path.backend.service.name}` + index}>{path.backend.serviceName ? path.backend.serviceName : path.backend.service.name}</div>);
            break;

          case "servicePort":
            children =
              Array.isArray(item.paths) &&
              item.paths.map((path: any, index: number) => <div key={`${path.backend.servicePort ? path.backend.servicePort : path.backend.service.port.number}` + index}>{path.backend.servicePort ? path.backend.servicePort : path.backend.service.port.number}</div>);
            break;

          default:
            children = item !== undefined ? item : "";
            break;
        }
        return {
          children,
          props: {
            "data-title": `${
              each_title === "host"
                ? "Domain"
                : each_title === "path"
                  ? "Path"
                  : each_title === "serviceName"
                    ? "Name"
                    : each_title === "servicePort"
                      ? "Service Port"
                      : ""
              }: `,
          },
        };
      },
    }));

    // event table
    const event_dataSource: event_new[] = ingress_event
      ? ingress_event.map((event: event_type_item) => {
        const type = event.type,
          description = event.reason,
          cause = event.note,
          key = event.metadata.uid,
          object = event.object;
        return (({ name, uid, creationTimestamp }) => ({ name, uid, key, creationTimestamp, type, description, cause, object }))(event.metadata);
      })
      : [];
    const event_title = ["type", "object", "description", "cause", "creationTimestamp"];
    const event_columns = event_title.map((event_title) => ({
      title: `${
        event_title === "type"
          ? "Type"
          : event_title === "object"
            ? "Object"
            : event_title === "description"
              ? "Description"
              : event_title === "cause"
                ? "Cause"
                : event_title === "creationTimestamp"
                  ? "Time"
                  : ""
        }`,
      dataIndex: event_title,
      key: event_title,
      render: (item: any) => {
        let children: JSX.Element | string;
        switch (event_title) {
          case "creationTimestamp":
            children = get_time(item);
            break;

          default:
            children = item !== undefined ? item : "";
            break;
        }
        return {
          children,
          props: {
            "data-title": `${
              event_title === "type"
                ? "Type"
                : event_title === "object"
                  ? "Object"
                  : event_title === "description"
                    ? "Description"
                    : event_title === "cause"
                      ? "Cause"
                      : event_title === "creationTimestamp"
                        ? "Time"
                        : ""
              }`,
          },
        };
      },
    }));

    table_list_modal.is_details &&
      table_list_modal.visible &&
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <Form.Item className="ant-col-sm-24">
            <div>
              <Descriptions
                title={formatMessage({ id: "basic_information" })}
                bordered
                layout="horizontal"
                size="small"
                column={1}
                className="basic_ingressInfo"
              >
                <Descriptions.Item label={formatMessage({ id: "name" })}>{item_selected?.name}</Descriptions.Item>
                <Descriptions.Item label={formatMessage({ id: "namespaces" })}>{item_selected?.namespace}</Descriptions.Item>
                <Descriptions.Item label={formatMessage({ id: "created_at" })}>
                  {item_selected?.creationTimestamp && get_time(item_selected?.creationTimestamp)}
                </Descriptions.Item>
                <Descriptions.Item label="Labels">{item_selected?.labels ? JSON.stringify(item_selected?.labels) : ""}</Descriptions.Item>
                <Descriptions.Item label="Annotations">{item_selected?.annotations ? JSON.stringify(item_selected?.annotations) : ""}</Descriptions.Item>
                <Descriptions.Item label="Endpoint">
                  {Array.isArray(item_selected?.loadBalancer) &&
                    item_selected?.loadBalancer &&
                    item_selected?.loadBalancer.map((each: any) => "  " + each.ip).toString()}
                </Descriptions.Item>
              </Descriptions>
              <br />
              <Descriptions title={formatMessage({ id: "rules" })}></Descriptions>
              <Table columns={table_columns} dataSource={table_dataSource} size="small" bordered={true} pagination={false} />
              <br />
              <Descriptions title={formatMessage({ id: "events" })}></Descriptions>
              <Table columns={event_columns} dataSource={event_dataSource} size="small" pagination={{
                pageSize: 6,
                hideOnSinglePage: true,
                showSizeChanger: false,
              }} />
            </div>
          </Form.Item>
        ),
        modal_title: ''
      }));
  }, [table_list_modal.is_details, table_list_modal.visible, set_table_list_modal, table_list_modal.is_yaml, item_selected, ingress_event, formatMessage]);

  useEffect((): void => {
    !workspace_selected && set_workspace_selected((workspaces && workspaces[0] && workspaces[0].metadata) || {});
    !workspace_selected && workspaces && set_workspace_new(workspaces[0]?.metadata?.labels && workspaces[0]?.metadata?.labels?.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaces, set_workspace_selected, workspace_selected?.name]);

  useEffect((): void => {
    (async (): Promise<void> => {
      if (table_list_modal.visible && user_info.is_globaladmin && !table_list_modal.is_logs && !table_list_modal.is_config) {
        const user_subscriptions_menu_new = (
          <Form.Item key="user_subscriptions" label={<FormattedMessage id="subscription_name" />} labelCol={{ sm: 10 }} wrapperCol={{ sm: 14 }} required>
            <Select
              showSearch
              value={subscription_id_local}
              filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
              onChange={(event: string) => {
                const subscription_id_new: string | undefined = (
                  user_subscriptions?.find((subscription_each) => subscription_each.id === event) || (user_subscriptions || [])[0]
                )?.id;
                if (subscription_id_new) set_subscription_id_local(subscription_id_new);
              }}
            >
              {Array.isArray(user_subscriptions) &&
                user_subscriptions.map(({ id, name, company }: user_subscription_all) => (
                  <Option key={name + company} value={id}>
                    <span className="font-w-6">{name}</span>
                    <span className="ml-10">{company}</span>
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
        set_user_subscriptions_menu(user_subscriptions_menu_new);
      }
    })();
  }, [table_list_modal.visible, user_info.is_globaladmin, user_subscriptions, subscription_id_local, table_list_modal.is_logs, table_list_modal.is_config]);

  // cluster initialization
  useEffect(() => {
    if (path.includes('clusters') && table_list_modal.visible && table_list_modal.is_initialization) {
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <Form labelAlign="left" layout="horizontal" className="cluster_init_form">
            <div className="init_title"><FormattedMessage id="config_host" /></div>
            <Form.Item
              key="ssh_user"
              labelCol={{ sm: 4 }}
              wrapperCol={{ sm: 14, offset: 6 }}
              label="ssh user"
              validateStatus={cluster_init_name_validate.status}
              help={cluster_init_name_validate.msg}
              className="px-30"
              required
            >
              <Input
                onBlur={(e: any) => { e.stopPropagation(); set_cluster_init_name_validate({ status: "", msg: null }); }}
                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                  if (event.keyCode === 13) event.preventDefault();
                }}
                onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                  const ssh_user_value = event.target?.value;
                  if (ssh_user_value?.length > 0) {
                    set_cluster_init_name_validate({ status: "success", msg: undefined });
                  } else {
                    set_cluster_init_name_validate({ status: "error", msg: formatMessage({ id: "this_field_is_required" }) })
                  }
                  set_ssh_user_new(ssh_user_value);
                }}
              />
            </Form.Item>
            <Form.Item key="pravite_key" labelCol={{ sm: 24 }} wrapperCol={{ sm: 24 }} label="pravite key" required className="px-30" validateStatus={pravite_key_validate.status}
              help={pravite_key_validate.msg}>
              <TextArea
                rows={4}
                onBlur={(e: any) => { e.stopPropagation(); set_pravite_key_validate({ status: "", msg: null }); }}
                onChange={({ target }: React.ChangeEvent<HTMLTextAreaElement>) => {
                  try {
                    if (target.value?.length > 0) {
                      set_pravite_key_validate({ status: "success", msg: undefined });
                    } else {
                      set_pravite_key_validate({ status: "error", msg: formatMessage({ id: "this_field_is_required" }) })
                    }
                    set_pravite_key_new(target.value);
                  } catch (err) {
                    console.error(err);
                  }
                }}
              />
            </Form.Item>
            <div className="init_title"><FormattedMessage id="install_package" /></div>
            <Form.Item className="px-30">
              <Checkbox className="helm_item" checked={nginx_controller_checked} onChange={(e: any) => { e.stopPropagation(); set_nginx_controller_checked(!nginx_controller_checked) }}>nginx controller</Checkbox>
            </Form.Item>
            <Form.Item className="px-30">
              <div>
                <Checkbox className="helm_item" checked={cluster_agent_checked} onChange={(e: any) => { e.stopPropagation(); set_cluster_agent_checked(!cluster_agent_checked) }}>clusteragent</Checkbox>
              </div>
              {cluster_agent_checked && <Row className="helm_package">
                <Col sm={6}>
                  <span>image version:</span>
                </Col>
                <Col offset={3} sm={15}>
                  <Input
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                      if (event.keyCode === 13) event.preventDefault();
                    }}
                    onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                      const image_version_value = event.target?.value;
                      set_image_version_new(image_version_value);
                    }}
                  />
                </Col>
              </Row>}
            </Form.Item>
            <Form.Item className="px-30">
              <div>
                <Checkbox className="helm_item" checked={log_slave_checked} onChange={(e: any) => { e.stopPropagation(); set_log_slave_checked(!log_slave_checked) }}>log slave</Checkbox>
              </div>
              {log_slave_checked && <Row className="helm_package">
                <Col sm={6}>
                  <span>master ip address:</span>
                </Col>
                <Col offset={3} sm={15}>
                  <Input
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                      if (event.keyCode === 13) event.preventDefault();
                    }}
                    onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                      const ip_address_value = event.target?.value;
                      set_ip_address_new(ip_address_value);
                    }}
                  />
                </Col>
              </Row>}
            </Form.Item>
            <Form.Item className="px-30">
              <div>
                <Checkbox className="helm_item" checked={rms_checked} onChange={(e: any) => { e.stopPropagation(); set_rms_checked(!rms_checked) }}>rms</Checkbox>
              </div>
              {rms_checked && <div>
                <Row className="helm_package">
                  <Col sm={6}>request storage:</Col>
                  <Col offset={3} sm={15}>
                    <Select showSearch defaultValue="32G" onChange={(e: any) => set_request_storage_new(e)}>
                      <Option key="16G" value="16G">16G</Option>
                      <Option key="32G" value="32G">32G</Option>
                      <Option key="64G" value="64G">64G</Option>
                    </Select>
                  </Col>
                </Row>
                <Row className="helm_package">
                  <Col sm={6}>support https:</Col>
                  <Col offset={3} sm={15}>
                    <Switch checked={support_https_checked} onChange={(e: any) => { set_support_https_checked(!support_https_checked) }} />
                  </Col>
                </Row>
              </div>}
            </Form.Item>
          </Form>
        ),
      }));
    }
  }, [table_list_modal.visible, user_info.is_globaladmin, table_list_modal.is_initialization, set_table_list_modal, nginx_controller_checked, cluster_agent_checked, log_slave_checked, rms_checked, support_https_checked, name_validate_exam, cluster_init_name_validate.status, cluster_init_name_validate.msg, pravite_key_validate.status, pravite_key_validate.msg, formatMessage, path]);

  useEffect(() => {
    if (ssh_user_new.length > 0 && pravite_key_new.length > 0) {
      set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false }));
    } else {
      set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }));
    }
  }, [ssh_user_new, pravite_key_new, set_table_list_modal])

  // workload scale
  useEffect((): void => {
    const replicasOptions = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
    if (path.includes('workloads') && table_list_modal.visible && table_list_modal.is_scale_replica) {
      set_scale_replica({ type: item_selected?.type, name: item_selected?.name, scale: item_selected?.scale });
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <div className="pl-10 workload_scale">
            <Row>
              <Col span={8}>
                <div className="scale_desc"><FormattedMessage id="now_replicas" /></div>
                <div className="text-center line-height_32">{item_selected?.scale}</div>
              </Col>
              <Col span={8} className="text-center">
                <img className="to_right_img" src={to_right} alt="assign" />
              </Col>
              <Col span={8}>
                <div className="scale_desc"><FormattedMessage id="new_replicas" /></div>
                <div className="w_100 ml-50">
                  <Select showSearch optionFilterProp="children" defaultValue={item_selected?.scale} className="w-100" onChange={(event: string) => {
                    set_scale_replica({ type: item_selected?.type, name: item_selected?.name, scale: event })
                  }}>
                    {
                      replicasOptions.map((each: string) => {
                        return <Option value={each} key={each}>{each}</Option>
                      })
                    }
                  </Select>
                </div>
              </Col>
            </Row>
          </div>
        )
      }));
    } else {
      set_scale_replica({ type: "", name: "", scale: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table_list_modal.is_scale_replica, table_list_modal.visible, set_table_list_modal, item_selected]);

  // workload edit yaml
  useEffect((): void => {
    if (path.includes('workloads') && table_list_modal.visible && (table_list_modal.is_edit_yaml || table_list_modal.is_view_yaml)) {
      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_message: (
          <div>
            <AceEditor
              focus
              style={{ width: "100%" }}
              mode="yaml"
              value={wk_edit_yaml_data ? yaml.safeDump(wk_edit_yaml_data) : "loading..."}
              onChange={(event: any) => {
                set_wk_edit_yaml_new({ type: item_selected.type, name: item_selected.name, content: event });
                // set_edit_yaml_disabled(false);
              }}
              theme="monokai"
              name="template_file"
              fontSize={18}
              showPrintMargin={false}
              showGutter={true}
              wrapEnabled={true}
              highlightActiveLine
              readOnly={table_list_modal.is_view_yaml ? true : false}
              setOptions={{
                showLineNumbers: true,
                tabSize: 2,
              }}
              editorProps={{ $blockScrolling: true }}
            />
            {
              table_list_modal.is_edit_yaml ?
                <div>
                  <Divider style={{ marginBottom: "10px" }} />
                  <div className="text-right">
                    <Button
                      key="edit_yaml_cancel"
                      className="ml-10"
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handle_cancel();
                      }}
                    >
                      <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                      key="edit_yaml_ok"
                      type="primary"
                      className="ml-10"
                      // disabled={edit_yaml_disabled}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        sure_edit_yaml();
                      }}
                    >
                      <FormattedMessage id="ok" />
                    </Button>
                  </div>
                </div> : <div></div>
            }
          </div>
        )
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table_list_modal.is_edit_yaml, table_list_modal.visible, set_table_list_modal, item_selected, wk_edit_yaml_data, table_list_modal.is_view_yaml, set_wk_edit_yaml_new, table_list_modal.origin]);

  useEffect(()=>{
    if(list_type === 'pvc' && datacenter_name && cluster_selected?.name && table_list_modal?.visible && table_list_modal?.action === 0 && !table_list_modal?.is_web_kubectl){
        (async ()=>{
            const storage_list: any = await worker_fetch({
                url: `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/storageclasses`,
                method: 0,
                props: {history, formatMessage},
                datacenter_name
            });
            if(storage_list?.data?.items?.length){
                set_storage_class_list(storage_list.data.items);
                set_storage_class_selected(storage_list?.data?.items[0]);
                set_storage_row_selected([storage_list?.data?.items[0]?.metadata?.name])
            }else {
                set_storage_class_list([]);
                set_storage_class_selected({});
                set_storage_row_selected([])
            }
        })()
    }
    // eslint-disable-next-line
}, [list_type, datacenter_name, cluster_selected?.name, table_list_modal?.visible, persistent_distribution_val]);
  
  // persistent
  useEffect(() => {
    if (table_list_modal.visible && persistent_page.find((val: string) => path.includes(val))) {
      const persistent_name: JSX.Element = (
        <Form.Item
          key="persistent_name"
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="name" />}
          validateStatus={name_validate.status}
          help={name_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
              const value = event.target?.value;
              input_regexp(value.length <= 0 ? 9 : 14, value, set_name_validate);
              set_persistent_name_val(value);
            }}
          />
        </Form.Item>
      );
      set_persistent_name_input(persistent_name);

      const persistent_type: JSX.Element = (
        <Form.Item
          key={'persistent_type'}
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="type" />}
        >
          <Select defaultValue={'Ceph-rbd'} onChange={(val: string) => set_persistent_type_val(val)}>
            <Option key={'Ceph-rbd'} value={'Ceph-rbd'} title={'Ceph-rbd'}>Ceph-rbd</Option>
            {/*<Option key={'NFS'} value={'NFS'} title={'NFS'}>NFS</Option>*/}
          </Select>
        </Form.Item>
      );
      set_persistent_type_input(persistent_type);

      const persistent_visit: JSX.Element = (
        <Form.Item
          key={'persistent_visit'}
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="visit_model" />}
        >
          <Select defaultValue={'ReadWriteOnce'} onChange={(val: string) => set_persistent_visit_val(val)}>
            <Option key={'ReadWriteOnce'} value={'ReadWriteOnce'}
              title={'ReadWriteOnce'}>ReadWriteOnce</Option>
            <Option key={'ReadOnlyMany'} value={'ReadOnlyMany'} title={'ReadOnlyMany'}>ReadOnlyMany</Option>
            <Option key={'ReadWriteMany'} value={'ReadWriteMany'}
              title={'ReadWriteMany'}>ReadWriteMany</Option>
          </Select>
        </Form.Item>
      );
      set_persistent_visit_input(persistent_visit);

      const persistent_recycle: JSX.Element = (
        <Form.Item
          key={'persistent_recycle'}
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="recycle_strategy" />}
        >
          <Select defaultValue={'Retain'} onChange={(val: string) => set_persistent_recycle_val(val)}>
            <Option key={'Retain'} value={'Retain'} title={'Retain'}>Retain</Option>
            <Option key={'Recycle'} value={'Recycle'} title={'Recycle'}>Recycle</Option>
            <Option key={'Delete'} value={'Delete'} title={'Delete'}>Delete</Option>
          </Select>
        </Form.Item>
      );
      set_persistent_recycle_input(persistent_recycle);

      const persistent_bind: JSX.Element = (
        <Form.Item
          key={'persistent_bind'}
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="bind_model" />}
        >
          <Select onChange={(val: string) => set_persistent_bind_val(val)}>
            <Option key={'Immediate'} value={'Immediate'} title={'Immediate'}>Immediate</Option>
            <Option key={'Immediate1'} value={'Immediate1'} title={'Immediate2'}>Immediate2</Option>
          </Select>
        </Form.Item>
      );
      set_persistent_bind_input(persistent_bind);

      const persistent_total: JSX.Element = (
        <Form.Item
          key={'persistent_total'}
          labelCol={{ sm: 5 }}
          wrapperCol={{ sm: 18, offset: 1 }}
          label={<FormattedMessage id="aggregate" />}
          validateStatus={persistent_total_validate.status}
          help={persistent_total_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            className={'has-after'}
            onChange={(event: any) => {
              const value = event?.target?.value;
              set_persistent_total_val(value);
              input_regexp(value.length <= 0 ? 9 : 3, value, set_persistent_total_validate)
            }}
            addonAfter={(
              <Select
                defaultValue={'Mi'}
                onChange={(val: string) => set_persistent_total_unit(val)}
                style={{ width: '70px' }}
                className={'input-select'}
              >
                <Option key={'Mi'} value={'Mi'} title={'Mi'}>Mi</Option>
                <Option key={'Gi'} value={'Gi'} title={'Gi'}>Gi</Option>
                <Option key={'Ti'} value={'Ti'} title={'Ti'}>Ti</Option>
                <Option key={'Pi'} value={'Pi'} title={'Pi'}>Pi</Option>
              </Select>
            )}
          />
        </Form.Item>
      );
      set_persistent_total_input(persistent_total);

      const persistent_distribution: JSX.Element = (
        <Row className={'persistent-parameter'}>
          <Col className={'parameter-label'} sm={5}><FormattedMessage id={'parameters'} /></Col>
          <Col offset={1} sm={18}>
            <Radio.Group onChange={(val: any) => { set_persistent_distribution_val(val?.target?.value || 1) }} defaultValue={1}>
              <Radio value={1}><FormattedMessage id={'create_pvc_radio1'} /></Radio>
              {/*<Radio value={2}>已有存储卷</Radio>*/}
              {/*<Radio value={3}>创建存储卷</Radio>*/}
            </Radio.Group>
          </Col>
        </Row>
      );
      set_persistent_distribution_input(persistent_distribution);
    }
  }, [
    table_list_modal.visible,
    path,
    name_validate,
    persistent_total_validate
  ]);

  const persistent_parameter_change = (key: string, val: any) => {
    const new_parameter: any = { ...persistent_parameter_val };
    new_parameter[`persistent_parameter_${key}`] = val?.target?.value || '';
    set_persistent_parameter_val(new_parameter)
  };

  useEffect(() => {
    if (table_list_modal.visible && persistent_page.find((val: string) => path.includes(val))) {
      const persistent_parameter: JSX.Element = (
        <Row className={'persistent-parameter'}>
          <Col className={'parameter-label'} sm={5}><FormattedMessage id={'parameters'} /></Col>
          <Col offset={1} sm={18}>
            <div className={'parameter-add'}>
              <span onClick={() => {
                set_persistent_parameter_arr(persistent_parameter_arr.length > 0 ? [...persistent_parameter_arr, ++persistent_parameter_arr[persistent_parameter_arr.length - 1]] : [1])
              }}>
                <FormattedMessage id={'add'} />
              </span>
            </div>
            <div className={'parameter-data'}>{persistent_parameter_arr.map((item: number, key: number) => (
              <Row key={item}>
                <Col className={'parameter-item'} span={11}>
                  <Form.Item key={`persistent_parameter_key_${item}`}>
                    <Input
                      onChange={(event: any) => persistent_parameter_change(`key_${item}`, event)} />
                  </Form.Item>
                </Col>
                <Col className={'parameter-item'} span={11}>
                  <Form.Item key={`persistent_parameter_val_${item}`}>
                    <Input
                      onChange={(event: any) => persistent_parameter_change(`val_${item}`, event)} />
                  </Form.Item>
                </Col>
                <Col className={'parameter-delete'} span={2}><DeleteOutlined onClick={() => {
                  const new_arr = [...persistent_parameter_arr];
                  new_arr.splice(key, 1);
                  set_persistent_parameter_arr(new_arr);
                }} /></Col>
              </Row>
            ))}</div>
          </Col>
        </Row>
      );
      set_persistent_parameter_input(persistent_parameter)
    }
    // eslint-disable-next-line
  }, [table_list_modal.visible, path, persistent_parameter_arr, persistent_parameter_val]);

  useEffect(() => {
    const persistent_already: JSX.Element = (
      <Row className={'persistent-parameter'}>
        <Col className={'parameter-label'} sm={24} style={{ textAlign: 'left', marginBottom: '5px' }}><FormattedMessage id={'existing_storage_class'} /></Col>
        <Col sm={24}>
          {/*<div className={'parameter-add'}>*/}
          {/*<span onClick={() => {}}>*/}
          {/*<FormattedMessage id={'select_storage_class'}/>*/}
          {/*</span>*/}
          {/*</div>*/}
          {/*</Col>*/}
          {/*<Col offset={6} sm={18}>*/}
          <Collapse>
            <Collapse.Panel
              key={1}
              disabled={storage_class_list.length <= 0}
              header={
                <Descriptions layout="vertical" bordered>
                  <Descriptions.Item label={formatMessage({ id: 'name' })}>{storage_class_selected?.metadata?.name}</Descriptions.Item>
                  <Descriptions.Item label={formatMessage({ id: 'create_time' })}>{format_time(storage_class_selected?.metadata?.creationTimestamp || '')}</Descriptions.Item>
                  <Descriptions.Item label={formatMessage({ id: 'provider' })}>{storage_class_selected?.provisioner}</Descriptions.Item>
                  <Descriptions.Item label={formatMessage({ id: 'recycle_strategy' })}>{storage_class_selected?.reclaimPolicy}</Descriptions.Item>
                  <Descriptions.Item label={formatMessage({ id: 'parameters' })} span={2}>{
                    storage_class_selected?.parameters && Object.keys(storage_class_selected.parameters)?.map((key: string) => (
                      <span key={key} className={'storage-parameters'}>{`${key}: ${storage_class_selected.parameters[key]}`}</span>
                    ))
                  }</Descriptions.Item>
                </Descriptions>
              }
            >
              <Table
                size={'small'}
                columns={[
                  {
                    title: <FormattedMessage id="name" />,
                    key: "name",
                    sorter: (a: any, b: any) => {
                      const a_name = a?.metadata?.name;
                      const b_name = b?.metadata?.name;
                      if (a_name && b_name) return a_name.localeCompare(b_name);
                    },
                    render: (item: any) => {
                      return {
                        children: (<span>{item?.metadata?.name}</span>),
                        props: {
                          "data-title": "Name: ",
                        },
                      };
                    },
                  },
                  {
                    title: <FormattedMessage id="provider" />,
                    key: "provider",
                    sorter: (a: any, b: any) => {
                      const a_name = a?.provisioner || '';
                      const b_name = b?.provisioner || '';
                      if (a_name && b_name) return a_name.localeCompare(b_name);
                    },
                    render: (item: any) => {
                      return {
                        children: (<span>{item?.provisioner}</span>),
                        props: {
                          "data-title": "Provider: ",
                        },
                      };
                    }
                  },
                  {
                    title: <FormattedMessage id="parameters" />,
                    key: "parameters",
                    render: (item: any) => {
                      const { parameters } = item || { parameters: {} };
                      return {
                        children: (parameters ? Object.keys(parameters)?.map((key: string) => (
                          <span key={key} className={'storage-parameters'}>{`${key}: ${parameters[key]}`}</span>
                        )) : ''),
                        props: {
                          "data-title": "Parameters: ",
                        },
                      };
                    }
                  },
                  {
                    title: <FormattedMessage id="recycle_strategy" />,
                    key: "recycle_strategy",
                    sorter: (a: any, b: any) => {
                      const a_name = a?.reclaimPolicy || '';
                      const b_name = b?.reclaimPolicy || '';
                      if (a_name && b_name) return a_name.localeCompare(b_name);
                    },
                    render: (item: any) => {
                      return {
                        children: (<span>{item?.reclaimPolicy}</span>),
                        props: {
                          "data-title": "Reclaim policy: ",
                        },
                      };
                    }
                  },
                  {
                    title: formatMessage({ id: "create_time" }),
                    key: 'create_time',
                    render: (item: any) => {
                      const create_time: any = item?.metadata?.creationTimestamp || '';
                      return {
                        children: (
                          <span>{create_time ? format_time(create_time) : "--/--/---- --:--:--"}</span>
                        ),
                        props: {
                          "data-title": "Create Time: ",
                        },
                      }
                    }
                  },
                ]}
                dataSource={storage_class_list}
                pagination={{
                  pageSize: 5,
                  hideOnSinglePage: true,
                  showSizeChanger: false
                }}
                rowKey={(item: any) => item?.metadata?.name}
                showSorterTooltip={false}
                rowSelection={{
                  type: 'radio',
                  selectedRowKeys: storage_row_selected,
                  onChange: (selectedRowKeys: any) => { set_storage_row_selected(selectedRowKeys) }
                }}
              />
            </Collapse.Panel>
          </Collapse>
        </Col>
        {!storage_class_selected?.metadata?.name && <Col sm={24} className={'modal-danger-text'}>* <FormattedMessage id={'no_storage_class'} /></Col>}
      </Row>
    );
    set_persistent_already_input(persistent_already);
    // eslint-disable-next-line
  }, [table_list_modal.visible, path, persistent_already_arr, persistent_already_val, storage_class_list, storage_class_selected, storage_row_selected]);

  useEffect(() => {
    if (persistent_tabs_val === 'yaml-input') {
      const name = persistent_name_val || '',
        accessModes = [persistent_visit_val || ''],
        storageClassName = storage_class_selected[0] || '',
        storage = `${persistent_total_val || ''}${persistent_total_unit || ''}`;
      const persistent_yaml: object = {
        apiVersion: 'v1',
        kind: 'PersistentVolumeClaims',
        metadata: {
          name: name
        },
        spec: {
          accessModes: accessModes,
          storageClassName: storageClassName,
          resources: {
            requests: {
              storage: storage
            }
          }
        }
      };
      set_persistent_yaml_val(persistent_yaml);
      set_persistent_yaml_edit_val(yaml.safeDump(persistent_yaml));
    }
    // eslint-disable-next-line
  }, [persistent_tabs_val]);

  useEffect(() => {
    if (table_list_modal.pv_yaml_data === 'action_success' && !table_list_modal?.visible) {
      set_table_list_modal((currentState) => ({
        ...currentState,
        pv_yaml_data: '',
      }))
    }
    // eslint-disable-next-line
  }, [table_list_modal?.pv_yaml_data]);

  useEffect(()=>{
    if(path.includes('cluster-info/workspaces') && table_list_modal?.visible && table_list_modal?.action <= 1 && cluster_selected?.name && datacenter_name){
      (async ()=>{
        const gpu_list: any = await worker_fetch({
          url: `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/nodes?nodetype=gpu`,
          method: 0,
          props: {history, formatMessage},
          datacenter_name
        });
        set_gpu_node_list(gpu_list?.data?.items || []);
        const cpu_list: any = gpu_list?.data?.totalCount > 0 && await worker_fetch({
            url: `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/nodes?nodetype=cpu`,
            method: 0,
            props: {history, formatMessage},
            datacenter_name
        });
        set_cpu_node_list(cpu_list?.data?.items || []);
        const {bindcpunodes, bindgpunodes} = item_selected?.labels || {};
        if(bindcpunodes){
          let new_cpu_list:any = [];
          // eslint-disable-next-line
          (cpu_list?.data?.items || []).map(({metadata}: any)=>{
            const find_item: any = bindcpunodes?.split(',').find((val: string)=> val === metadata?.name);
            if(find_item) new_cpu_list.push(metadata?.name)
          })
          set_cpu_node_selected(new_cpu_list);
        }
        if(bindgpunodes){
          let new_gpu_list: any = [];
          // eslint-disable-next-line
          (gpu_list?.data?.items || []).map(({metadata}: any)=>{
            const find_item: any = bindgpunodes?.split(',').find((val: string)=> val === metadata?.name);
            if(find_item) new_gpu_list.push(metadata?.name)
          })
          set_gpu_node_selected(new_gpu_list)
        }
      })()
    }
    // eslint-disable-next-line
  }, [path, table_list_modal?.visible, table_list_modal?.action, datacenter_name, cluster_selected?.name])

  // 顯示創建確認視窗
  useEffect(() => {
    if (
      (table_list_modal.action < 2 || table_list_modal.action === 10) &&
      !table_list_modal.is_config &&
      !table_list_modal.is_logs &&
      !table_list_modal.is_details &&
      !table_list_modal.is_web_kubectl &&
      !table_list_modal.is_initialization &&
      !table_list_modal.is_scale_replica &&
      !table_list_modal.is_edit_yaml &&
      !table_list_modal.is_sure_edit &&
      !table_list_modal.is_view_yaml &&
      !table_list_modal.is_delete_pod &&
      !table_list_modal.is_restartLogs &&
      table_list_modal.visible
    ) {
      const is_create = table_list_modal.action === 0,
        is_edit = table_list_modal.action === 1 && !table_list_modal.is_yaml,
        is_yaml = table_list_modal.action === 1 && table_list_modal.is_yaml,
        is_pv_yaml = table_list_modal.action === 10 && table_list_modal.is_yaml,
        pv_yaml_data = table_list_modal?.pv_yaml_data;
      let create_edit: JSX.Element = <Form></Form>;
      const autoscale_level: string[] = ["globalAdmin", "datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner"];
      const is_quota = path.includes("quotas"),
        name_input = (
          <Form.Item
            key="name_input"
            labelCol={{ sm: is_quota ? 10 : 4 }}
            wrapperCol={{ sm: is_quota ? 14 : 14, offset: is_quota ? 0 : 6 }}
            label={<FormattedMessage id="name" />}
            validateStatus={name_validate.status}
            help={name_validate.msg}
            hasFeedback
            className="validate_icon"
            required={true}
          >
            <Input
              maxLength={32}
              pattern={`${path.includes("workspaces") || path.includes("namespaces") ? RegExp(/^[0-9a-z]{1,16}/) : RegExp(/^[a-z0-9.-]/)}`}
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                if (event.keyCode === 13) event.preventDefault();
              }}
              onChange={async (event: React.ChangeEvent<HTMLInputElement>) => {
                const value = event.target?.value;
                name_validate_exam(value);
                set_name_new(value);
              }}
            />
          </Form.Item>
        ),
        cluster_create_edit: JSX.Element = (
          <Form labelAlign="left" layout="horizontal">
            {is_create && [
              name_input,
              <Form.Item key="type" labelCol={{ sm: 4 }} wrapperCol={{ sm: 14, offset: 6 }} label={<FormattedMessage id="type" />} required>
                <Select
                  defaultValue="dedicate"
                  onChange={(event: string) => {
                    set_type_selected(event);
                  }}
                >
                  <Option value="dedicate" key="dedicate">
                    Dedicate Cluster
                  </Option>
                  <Option value="shared" key="shared">
                    Shared Cluster
                  </Option>
                </Select>
              </Form.Item>,
              user_subscriptions_menu,
              <Form.Item key="config" labelCol={{ sm: 24 }} wrapperCol={{ sm: 24 }} label={<FormattedMessage id="config" />} required>
                <TextArea
                  rows={5}
                  onChange={({ target }: React.ChangeEvent<HTMLTextAreaElement>) => {
                    try {
                      set_config_new(yaml.load(target.value));
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                />
              </Form.Item>,
            ]}
          </Form>
        ),
        cpu_nodes: JSX.Element = (
          gpu_node_list?.length > 0 ? <Form.Item
            key="cpu_nodes"
            labelCol={{ sm: 4 }}
            wrapperCol={{ sm: 14, offset: 6 }}
            label={<FormattedMessage id="cpu_nodes" />}
            hasFeedback
          >
            <Select
              className='multiple-select-item'
              mode='multiple' 
              allowClear
              value={cpu_node_selected || []}
              getPopupContainer={(node: any)=> node.parentNode}
              disabled={table_list_modal.action > 0 ? true : false}
              onChange={(data: any)=>{
                set_cpu_node_selected(data); 
                table_list_modal.modal_ok_button && set_table_list_modal((current: any)=>({...current, modal_ok_button: false}))
              }}
            >{
              cpu_node_list?.map(({metadata}: any)=>(<Select.Option key={metadata?.name} value={metadata?.name}>{metadata?.name}</Select.Option>))
            }</Select>
          </Form.Item> : <span></span>
        ),
        gpu_nodes: JSX.Element = (
          gpu_node_list.length > 0 ? <Form.Item
            key="gpu_nodes"
            labelCol={{ sm: 4 }}
            wrapperCol={{ sm: 14, offset: 6 }}
            label={<FormattedMessage id="gpu_nodes" />}
            hasFeedback
          >
            <Select
              className='multiple-select-item'
              mode='multiple' 
              allowClear
              value={gpu_node_selected || []}
              getPopupContainer={(node: any)=> node.parentNode}
              disabled={table_list_modal.action > 0 ? true : false}
              onChange={(data: any)=>{
                set_gpu_node_selected(data);
                table_list_modal.modal_ok_button && set_table_list_modal((current: any)=>({...current, modal_ok_button: false}))
              }}
            >{
              gpu_node_list?.map(({metadata}: any)=>(<Select.Option key={metadata?.name} value={metadata?.name}>{metadata?.name}</Select.Option>))
            }</Select>
          </Form.Item> : <span></span>
        ),
        space_create_edit: JSX.Element = (
          <Form labelAlign="left" layout="horizontal">
            {is_create && [name_input, ...(has_local_user_subscription ? [user_subscriptions_menu] : []), ...( datacenter_name && enable_autoscale !== "enable" ?  (path.includes('cluster-info/workspaces') && type_name === "dedicate" ? [workspace_auto_scale] : []) : (path.includes('cluster-info/workspaces') ? [workspace_auto_scale] : [])), ...(path.includes('cluster-info/workspaces') ? [cpu_nodes, gpu_nodes]: []), !wk_auto_scale && assign_list, !wk_auto_scale && quota_info_list]}
            {is_edit && [
              <Fragment>
                <Form.Item
                  labelCol={{ sm: 4 }}
                  wrapperCol={{ sm: 14, offset: 6 }}
                  label={<FormattedMessage id="name" />}
                  validateStatus={name_validate.status}
                  help={name_validate.msg}
                  hasFeedback
                  className="validate_icon"
                  required={true}
                >
                  <Input
                    defaultValue={(path.includes("workspace") ? item_selected?.labels : item_selected)?.name}
                    maxLength={32}
                    pattern={`${RegExp(/^[0-9a-z]{1,16}/)}`}
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                      if (event.keyCode === 13) event.preventDefault();
                    }}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      name_validate_exam(event.target.value);
                      set_name_new(event.target.value);
                    }}
                  />
                </Form.Item>
                { datacenter_name && enable_autoscale !== "enable" ?  (type_name === "dedicate" && path.includes('cluster-info/workspaces') && autoscale_level.indexOf(user_info.role) > -1 ? workspace_auto_scale : <div></div>) : (path.includes('cluster-info/workspaces') && autoscale_level.indexOf(user_info.role) > -1 ? workspace_auto_scale : <div></div>)}

              </Fragment>,
              ...(path.includes('cluster-info/workspaces') ? [cpu_nodes, gpu_nodes]: []),
              !wk_auto_scale && assign_list,
              !wk_auto_scale && quota_info_list
            ]}
            {(is_yaml || is_pv_yaml) && (
              <Fragment>
                <Form.Item>
                  <AceEditor
                    focus
                    style={{ width: "100%" }}
                    mode="yaml"
                    // value={ingress_new ? JSON.stringify(ingress_new, null, '\t')  : 'loading...'}
                    value={(ingress_new || pv_yaml_data) ? yaml.safeDump((ingress_new || pv_yaml_data)) : "loading..."}
                    // onChange={this.onChange}
                    theme="monokai"
                    name="template_file"
                    fontSize={18}
                    showPrintMargin={false}
                    showGutter={true}
                    wrapEnabled={true}
                    highlightActiveLine
                    readOnly={true}
                    setOptions={{
                      showLineNumbers: true,
                      tabSize: 2,
                    }}
                    editorProps={{ $blockScrolling: true }}
                  />
                </Form.Item>
                <Divider style={{ marginBottom: "10px" }} />
                <Form.Item className="text-right" style={{ marginBottom: "-14px" }}>
                  {!is_pv_yaml && <Button
                    key="4"
                    type="primary"
                    className="ml-10"
                    onClick={() => {
                      set_loading({ yaml_ingress: true });
                    }}
                  >
                    {loading.yaml_ingress ? <LoadingOutlined spin /> : <FormattedMessage id="refresh" />}
                  </Button>}
                  {/* <Button key='5' type="primary" className="ml-10" onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => { download_ingress(event) }}>
                                    download
                                </Button> */}
                  {/* <Button key='6' type="primary" className="ml-10">
                                    Save As
                                </Button> */}
                  <Button
                    key="7"
                    className="ml-10"
                    onClick={() => {
                      handle_cancel();
                    }}
                  >
                    <FormattedMessage id="cancel" />
                  </Button>
                </Form.Item>
              </Fragment>
            )}
          </Form>
        ),
        node_create_edit: JSX.Element = (
          <Form labelAlign="left" layout="horizontal">
            {is_create && [
              name_input,
              <Form.Item key="description" labelCol={{ sm: 4 }} wrapperCol={{ sm: 14, offset: 6 }} label="Description">
                <Col sm={24}>
                  <TextArea />
                </Col>
              </Form.Item>,
            ]}
          </Form>
        ),
        quota_create_edit: JSX.Element = (
          <Form labelAlign="right" layout="horizontal" className="more_rows">
            {is_create && name_input}
            {path.includes("namespace-quotas") && workspace_input}
            {path.includes("workspace-quotas") && gpu_input}
            {cpu_request_input}
            {cpu_input}
            {memory_request_input}
            {memory_input}
            {rootfs_request_input}
            {rootfs_input}
            {pvc_input}
            {pv_input}
            {pod_input}
            {service_input}
            {secret_input}
            {configmap_input}
            {path.includes("namespace-quotas") && gpu_input}
          </Form>
        ),
        pv_create_edit: JSX.Element = (
          <Form labelAlign="right" layout="horizontal">
              {persistent_name_input}
              {persistent_type_input}
              {persistent_total_input}
              {persistent_parameter_input}
              {persistent_visit_input}
              {persistent_recycle_input}
              {/*{persistent_bind_input}*/}
          </Form>
        ),
        pvc_create_edit: JSX.Element = (
            <Form labelAlign="right" layout="horizontal">
                {persistent_name_input}
                {persistent_distribution_input}
                {persistent_distribution_val === 3 && persistent_type_input}
                {persistent_total_input}
                {persistent_distribution_val !== 2 && persistent_visit_input}
                {persistent_distribution_val === 3 && persistent_recycle_input}
                {persistent_distribution_val === 3 && persistent_parameter_input}
                {persistent_distribution_val !== 3 && persistent_already_input}
            </Form>
        );

      switch (path) {
        case "clusters":
          create_edit = cluster_create_edit;
          break;
        case "workspaces":
          create_edit = space_create_edit;
          break;
        case "nodes":
          create_edit = node_create_edit;
          break;
        case "quotas/workspace-quotas":
          create_edit = quota_create_edit;
          break;
        case "quotas/namespace-quotas":
          create_edit = quota_create_edit;
          break;
        case "workspace-info/namespaces":
          create_edit = space_create_edit;
          break;
          case 'storage-info/pv':
            create_edit = is_pv_yaml? space_create_edit :pv_create_edit;
            break;
        case 'storage-info/pvc':
            create_edit = is_pv_yaml? space_create_edit :pvc_create_edit;
            create_edit = is_pv_yaml? space_create_edit : (<Tabs
                className={'persistent-tabs'}
                defaultActiveKey={'form-input'}
                onChange={(activeKey: string)=>{set_persistent_tabs_val(activeKey)}}
            >
              <Tabs.TabPane key={'form-input'} tab={formatMessage({id: 'form'})}>
                  {path === 'storage-info/pv' && pv_create_edit}
                  {path === 'storage-info/pvc' && pvc_create_edit}
              </Tabs.TabPane>
              <Tabs.TabPane key={'yaml-input'} tab={'Yaml'}>
                  <AceEditor
                      focus
                      style={{width: "100%"}}
                      mode="yaml"
                      value={yaml.safeDump(persistent_yaml_val)}
                      onChange={(even: any)=> set_persistent_yaml_edit_val(even)}
                      theme="monokai"
                      name="template_file"
                      fontSize={18}
                      showPrintMargin={false}
                      showGutter={true}
                      wrapEnabled={true}
                      highlightActiveLine
                      setOptions={{
                          showLineNumbers: true,
                          tabSize: 2,
                      }}
                  />
              </Tabs.TabPane>
          </Tabs>);
          break;
        default:
          create_edit = space_create_edit;
          break;
      }

      set_table_list_modal((currentState) => ({
        ...currentState,
        modal_title: is_create
          ? `${formatMessage({ id: list_type.includes("storage") ? list_type.substr(0, list_type.length - 1) : list_type === 'clusters' ? 'create_cluster_lower' : list_type === 'workspaces' ? 'create_workspace_lower' : list_type === 'namespaces' ? 'create_namespace_lower' : list_type === 'workspacequotas' ? 'create_workspacequota_lower' : list_type === 'namespacequotas' ? 'create_namespacequota_lower' : list_type })}`
          : is_edit
            ? `${item_selected?.key ? formatMessage({ id: item_selected.key === 'clusters' ? 'edit_cluster_lower' : item_selected.key === 'workspaces' || item_selected.key === 'workspace' ? 'edit_workspace_lower' : item_selected.key === 'namespace' ? 'edit_namespace_lower' : item_selected.key }) : ""}`
            : is_yaml || is_pv_yaml
              ? `${formatMessage({ id: "view" })} Yaml`
              : "",
        modal_message: create_edit,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    table_list_modal.visible,
    assign_list,
    configmap_input,
    gpu_input,
    cpu_request_input,
    cpu_input,
    formatMessage,
    item_selected,
    list_type,
    name_validate,
    memory_request_input,
    memory_input,
    path,
    pod_input,
    pv_input,
    pvc_input,
    quota_info_list,
    rootfs_request_input,
    rootfs_input,
    secret_input,
    service_input,
    workspace_input,
    has_local_user_subscription,
    name_validate_exam,
    user_subscriptions_menu,
    table_list_modal.action,
    set_table_list_modal,
    table_list_modal.is_logs,
    table_list_modal.is_config,
    table_list_modal.is_details,
    table_list_modal.is_yaml,
    ingress_new,
    loading.yaml_ingress,
    handle_cancel,
    table_list_modal.is_web_kubectl,
    table_list_modal.is_initialization,
    table_list_modal.is_scale_replica,
    table_list_modal.is_edit_yaml,
    table_list_modal.is_sure_edit,
    table_list_modal.is_view_yaml,
    table_list_modal.is_delete_pod,
    workspace_auto_scale,
    wk_auto_scale,
    type_name,
    user_info.role,
    enable_autoscale,
    table_list_modal.is_restartLogs,
    persistent_type_input,
    persistent_visit_input,
    persistent_recycle_input,
    persistent_bind_input,
    persistent_parameter_input,
    persistent_total_input,
    persistent_name_input,
    persistent_distribution_input,
    persistent_distribution_val,
    persistent_already_input,
    persistent_yaml_val,
    cpu_node_list,
    gpu_node_list,
    cpu_node_selected,
    gpu_node_selected
  ]);

  useEffect(
    (): void => {
      const validate = (
        funcs: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
        event: React.KeyboardEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>,
        message: string
      ) => {
        const value = (event.target as HTMLInputElement).value,
          pattern = new RegExp((event.target as HTMLInputElement).pattern.replace(/\//gi, ""));
        const valid: boolean = pattern.test(value);
        if ((event.target as HTMLInputElement).value.length) {
          funcs[0](!valid ? { status: "error", msg: `Only ${message} allowed` } : { status: "success", msg: null });
          funcs[1]((event.target as HTMLInputElement).value);
        } else {
          funcs[0]({ status: "", msg: null });
          funcs[1]((event.target as HTMLInputElement).value);
        }
      };

      function validate_number(
        this: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
        event: React.KeyboardEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
      ) {
        validate(this, event, "0-9 Digital");
      }

      const validate_1 = (
        funcs: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
        event: React.KeyboardEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
      ) => {
          const value = (event.target as HTMLInputElement).value;
          if (value?.length <= 0) {
              funcs[0]({status: "error", msg: formatMessage({id: "this_field_is_required"})});
              funcs[1](value)
          } else {
              funcs[0]({status: "", msg: null});
              validate(funcs, event, "0-9 Digital")
          }
      };

      function validate_required(
          this: [React.Dispatch<React.SetStateAction<any>>, React.Dispatch<React.SetStateAction<any>>],
          event: React.KeyboardEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>
      ) {
          path.includes("workspace-quotas") ? validate_1(this, event) : validate(this, event, "0-9 Digital")
      }

      const gpu_input_new: JSX.Element = (
          <Form.Item
              labelCol={{sm: 10}}
              wrapperCol={{sm: 14}}
              label="GPU Request"
              validateStatus={gpu_validate.status}
              help={gpu_validate.msg}
              hasFeedback
              className="validate_icon"
          >
              <Input
                  pattern={`${RegExp(/^[0-9.]+$/)}`}
                  onKeyUp={validate_number.bind([set_gpu_validate, set_gpu_new])}
                  onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                      if (event.keyCode === 13) event.preventDefault();
                  }}
                  onChange={validate_number.bind([set_gpu_validate, set_gpu_new])}
              />
          </Form.Item>
      );
      set_gpu_input(gpu_input_new);

      const cpu_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="CPU Limit(Core)"
          validateStatus={cpu_validate.status}
          help={cpu_validate.msg}
          hasFeedback
          className="validate_icon"
          required={path.includes("workspace-quotas")}
        >
          <Input
              pattern={`${RegExp(/^[0-9.]+$/)}`}
              onKeyUp={validate_required.bind([set_cpu_validate, set_cpu_new])}
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                  if (event.keyCode === 13) event.preventDefault();
              }}
              onChange={validate_required.bind([set_cpu_validate, set_cpu_new])}
          />
        </Form.Item>
      );
      set_cpu_input(cpu_input_new);

      const cpu_input_request_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="CPU Request(Core)"
          validateStatus={cpu_request_validate.status}
          help={cpu_request_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9.]+$/)}`}
            onKeyUp={validate_number.bind([set_cpu_request_validate, set_cpu_request_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
            onChange={validate_number.bind([set_cpu_request_validate, set_cpu_request_new])}
          />
        </Form.Item>
      );
      set_cpu_request_input(cpu_input_request_new);

      const rootfs_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label={[<FormattedMessage key={'limit_rootfs_1'} id="rootfs" />,
          <span key={'limit_rootfs_2'}>&nbsp;Limit({unit_provide})</span>]}
          validateStatus={rootfs_validate.status}
          help={rootfs_validate.msg}
          hasFeedback
          className="validate_icon"
          required={path.includes("workspace-quotas")}
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            maxLength={12}
            onKeyUp={validate_required.bind([set_rootfs_validate, set_rootfs_new])}
            onChange={validate_required.bind([set_rootfs_validate, set_rootfs_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_rootfs_input(rootfs_input_new);

      const rootfs_request_input_new: JSX.Element = (
        <Form.Item
          labelCol={{sm: 10}}
          wrapperCol={{sm: 14}}
          label={[<FormattedMessage key={'request_rootfs_1'} id="rootfs"/>,
              <span key={'request_rootfs_2'}>&nbsp;Request({unit_provide})</span>]}
          validateStatus={rootfs_request_validate.status}
          help={rootfs_request_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
              pattern={`${RegExp(/^[0-9]+$/)}`}
              maxLength={12}
              onKeyUp={validate_number.bind([set_rootfs_request_validate, set_rootfs_request_new])}
              onChange={validate_number.bind([set_rootfs_request_validate, set_rootfs_request_new])}
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                  if (event.keyCode === 13) event.preventDefault();
              }}
          />
        </Form.Item>
    );
    set_rootfs_request_input(rootfs_request_input_new);

      const pod_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="Pod"
          validateStatus={pod_validate.status}
          help={pod_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            onKeyUp={validate_number.bind([set_pod_validate, set_pod_new])}
            onChange={validate_number.bind([set_pod_validate, set_pod_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_pod_input(pod_input_new);

      const pvc_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label={[<FormattedMessage id="pvc_disk" />, <span> ({unit_provide})</span>]}
          validateStatus={pvc_validate.status}
          help={pvc_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            maxLength={12}
            onKeyUp={validate_number.bind([set_pvc_validate, set_pvc_new])}
            onChange={validate_number.bind([set_pvc_validate, set_pvc_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_pvc_input(pvc_input_new);

      const pv_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="PVC"
          validateStatus={pv_validate.status}
          help={pv_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            onKeyUp={validate_number.bind([set_pv_validate, set_pv_new])}
            onChange={validate_number.bind([set_pv_validate, set_pv_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_pv_input(pv_input_new);

      const service_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="Service"
          validateStatus={service_validate.status}
          help={service_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            onKeyUp={validate_number.bind([set_service_validate, set_service_new])}
            onChange={validate_number.bind([set_service_validate, set_service_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_service_input(service_input_new);

      const secret_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="Secret"
          validateStatus={secret_validate.status}
          help={secret_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            onKeyUp={validate_number.bind([set_secret_validate, set_secret_new])}
            onChange={validate_number.bind([set_secret_validate, set_secret_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
          />
        </Form.Item>
      );
      set_secret_input(secret_input_new);

      const configmap_input_new: JSX.Element = (
        <Form.Item
          labelCol={{ sm: 10 }}
          wrapperCol={{ sm: 14 }}
          label="ConfigMap"
          validateStatus={configmap_validate.status}
          help={configmap_validate.msg}
          hasFeedback
          className="validate_icon"
        >
          <Input
            pattern={`${RegExp(/^[0-9]+$/)}`}
            onKeyUp={validate_number.bind([set_configmap_validate, set_configmap_new])}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === 13) event.preventDefault();
            }}
            onChange={validate_number.bind([set_configmap_validate, set_configmap_new])}
          />
        </Form.Item>
      );
      set_configmap_input(configmap_input_new);
    },
    // eslint-disable-next-line
    [
      unit_provide,
      workspace_new,
      configmap_validate,
      cpu_validate,
      pod_validate,
      pv_validate,
      pvc_validate,
      rootfs_validate,
      secret_validate,
      service_validate,
      workspaces,
    ]
  );

  useEffect((): void => {
    if (datacenter_name && enable_autoscale !== "enable") {
      if(path.includes('cluster-info/workspaces') && table_list_modal.visible && type_name === 'dedicate') {
        set_wk_min_quota(item_selected?.labels?.minquota || autoQuotas[0]);
        set_wk_max_quota(item_selected?.labels?.maxquota || autoQuotas[15]);
        set_wk_timeout(item_selected?.labels?.scaleindefer || timeoutOptions[0]);
        if (table_list_modal.action === 1) {
          item_selected?.labels?.autoscale ? set_wk_auto_scale(true) : set_wk_auto_scale(false);
          const now_cpu = item_selected?.cpu?.totalCPU;
          const now_memory = item_selected?.memory?.totalMemory;
          const cpu_new_index = Number(now_cpu) >= 0 ? Math.ceil(Number(now_cpu) / 0.5) : 16;
          const memory_new_index = Number(now_memory) >= 0 ? Math.ceil(Number(now_memory) / 2048) : 16;
          const quota_index = cpu_new_index > memory_new_index ? cpu_new_index - 1 : memory_new_index - 1;
          set_wk_autoscale_workspaceQuota(autoQuotas[quota_index]);
        }
      }
    } else {
      if(path.includes('cluster-info/workspaces') && table_list_modal.visible) {
        set_wk_min_quota(item_selected?.labels?.minquota || autoQuotas[0]);
        set_wk_max_quota(item_selected?.labels?.maxquota || autoQuotas[15]);
        set_wk_timeout(item_selected?.labels?.scaleindefer || timeoutOptions[0]);
        if (table_list_modal.action === 1) {
          item_selected?.labels?.autoscale ? set_wk_auto_scale(true) : set_wk_auto_scale(false);
          const now_cpu = item_selected?.cpu?.totalCPU;
          const now_memory = item_selected?.memory?.totalMemory;
          const cpu_new_index = Number(now_cpu) >= 0 ? Math.ceil(Number(now_cpu) / 0.5) : 16;
          const memory_new_index = Number(now_memory) >= 0 ? Math.ceil(Number(now_memory) / 2048) : 16;
          const quota_index = cpu_new_index > memory_new_index ? cpu_new_index - 1 : memory_new_index - 1;
          set_wk_autoscale_workspaceQuota(autoQuotas[quota_index]);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[enable_autoscale, path, table_list_modal.visible, table_list_modal.action, item_selected?.labels?.autoscale, autoQuotas, type_name])

  useEffect((): void => {
    if (datacenter_name && enable_autoscale !== "enable") {
      if(path.includes('cluster-info/workspaces') && table_list_modal.visible && user_info.role && user_info.role !== "" && user_info.role !== "workspaceOwner") {
        if(table_list_modal.action === 1 && item_selected?.labels?.name) {
          (wk_auto_scale || (name_new !== '' && name_new !== item_selected?.labels?.name) || worksapce_default_quota !== item_selected?.quotaName || (!wk_auto_scale && wk_auto_scale_false === "true") ) ? set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false })) : set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }));
          wk_auto_scale && !name_new && set_name_new(item_selected?.labels?.name)
        } else if(table_list_modal.action === 0) {
          set_wk_autoscale_workspaceQuota(wk_min_quota);
          name_new !== "" ? set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false })) : set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }))
        }
      }
    } else {
      if(path.includes('cluster-info/workspaces') && table_list_modal.visible && user_info.role && user_info.role !== "") {
        if(table_list_modal.action === 1 && item_selected?.labels?.name) {
          (wk_auto_scale || (name_new !== '' && name_new !== item_selected?.labels?.name) || worksapce_default_quota !== item_selected?.quotaName || (!wk_auto_scale && wk_auto_scale_false === "true") || user_info.ssoRole === "globalAdmin" ) ? set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false })) : set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }));
          wk_auto_scale && !name_new && set_name_new(item_selected?.labels?.name)
        } else if(table_list_modal.action === 0) {
          set_wk_autoscale_workspaceQuota(wk_min_quota);
          (name_new !== "" || user_info.ssoRole === "globalAdmin") ? set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: false })) : set_table_list_modal((currentState) => ({ ...currentState, modal_ok_button: true }))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[enable_autoscale, path, table_list_modal.visible, table_list_modal.action, wk_auto_scale, wk_auto_scale_false, name_new, item_selected?.labels?.name, set_table_list_modal, user_info.role, worksapce_default_quota, user_info.ssoRole, type_name])

  useEffect((): void => {
    (async () => {
      if (!(datacenter_name && enable_autoscale !== "enable")) {
        if (path.includes('cluster-info/workspaces') && table_list_modal.visible && (table_list_modal.action === 0 || table_list_modal.action === 1) && user_info.role && user_info.role !== "" && datacenter_name) {
          if (user_info.ssoRole === "globalAdmin") {
            set_wk_auto_scale_disabled(false)
          } else {
            if (type_name === "dedicate" && cluster_selected?.name) {
              const delicate_cluster_res = ((await (await fetch(`/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/subscription`)).json()) as unknown) as autoScale_subsription_type;
              (user_info?.ssoSubscriptions.find((item: subscriptionType) => (item.subscriptionId === delicate_cluster_res?.subscriptionId) && (item.subscriptionRole?.toLocaleLowerCase() === "admin"))) ? set_wk_auto_scale_disabled(false) : set_wk_auto_scale_disabled(true);
            }

            if (type_name === "shared" && cluster_selected?.name && workspace_selected?.name) {
              const general_workspace_res = ((await (await fetch(`/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/workspace/${workspace_selected?.name}/subscription`)).json()) as unknown) as autoScale_subsription_type;
              user_info?.ssoSubscriptions.find((item: subscriptionType) => item.subscriptionId === general_workspace_res?.subscriptionId && item.subscriptionRole?.toLocaleLowerCase() === "admin") ? set_wk_auto_scale_disabled(false) : set_wk_auto_scale_disabled(true);
            }
          }
        }
      }
    })()
    // eslint-disable-next-line
  }, [enable_autoscale, path, table_list_modal.visible, table_list_modal.action, user_info.role, user_info.ssoRole, type_name, datacenter_name, cluster_selected?.name, workspace_selected?.name, user_info?.ssoSubscriptions, type_name])

  useEffect((): void => {

    if (datacenter_name && enable_autoscale !== "enable") {
      if (path.includes('cluster-info/workspaces') && table_list_modal.visible  && type_name === 'dedicate' && (table_list_modal.action === 0 || table_list_modal.action === 1) && user_info.role && user_info.role !== "") {
        const timeoutOptions = ['10', '20', '30', '40'];
        const now_cpu = item_selected?.cpu?.totalCPU;
        const now_memory = item_selected?.memory?.totalMemory;
        const cpu_new_index = Number(now_cpu) >= 0 ? Math.ceil(Number(now_cpu) / 0.5) : 16;
        const memory_new_index = Number(now_memory) >= 0 ? Math.ceil(Number(now_memory) / 2048) : 16;
        const quota_index = cpu_new_index > memory_new_index ? cpu_new_index - 1 : memory_new_index - 1;
        const workspace_auo_scale_new: JSX.Element = (
          <Fragment>
            <Form.Item
              key="auto_scale"
              className={`${wk_auto_scale ? "autoscale_border_left autoscale_border_right autoscale_border_top mb-0 pb-24 pl-10 pt-10" : ""}` }
              labelCol={{ sm: 10 }}
              wrapperCol={{ sm: 14, offset: 0 }}
              label={<div><FormattedMessage id="auto_scale" /><Tooltip placement="top" title={<FormattedMessage id="auto_scale_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
              >
            <Switch disabled={user_info.role === "workspaceOwner" ? true : false} checkedChildren="true" unCheckedChildren="false" checked={wk_auto_scale} onChange={(checked: boolean, event: Event) => { event.stopPropagation(); set_wk_auto_scale(checked); set_wk_auto_scale_false(checked ? '' : 'true'); }} />
            </Form.Item>
            {
              wk_auto_scale ?
                <div>
                  <div className={`${wk_auto_scale ? "autoscale_border_left autoscale_border_right autoscale_border_bottom mb-24" : ""}`}>
                  <Form.Item
                    key="defer_scale-in_for"
                    labelCol={{ sm: 9 }}
                    wrapperCol={{ sm: 15, offset: 0 }}
                    label={<div><FormattedMessage id="defer_scale-in_for" /><Tooltip placement="top"  title={<FormattedMessage id="defer_scale-in_for_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                    hasFeedback
                    className="validate_icon ml-40"
                    required={user_info.role === "workspaceOwner" ? false : true}>
                    <Select
                      // defaultValue={timeoutOptions[0]}
                      defaultValue={wk_timeout}
                      className="w-75 ml-14"
                      disabled={user_info.role === "workspaceOwner" ? true : false}
                      onChange={(event: string) => {
                        set_wk_timeout(event);
                      }}>
                      {
                        timeoutOptions.map((item_value: string) => <Option value={item_value} key={item_value} >{item_value}</Option>
                        )
                      }
                    </Select>
                    <span className="px-6"><FormattedMessage id="minutes" /></span>
                  </Form.Item>
                  {
                    table_list_modal.action === 0 ?
                      <div>
                        <Form.Item
                          key="min_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="min_quota" /><Tooltip placement="top"  title={<FormattedMessage id="min_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_min_quota}
                            className="w-75"
                            disabled={user_info.role === "workspaceOwner" ? true : false}
                            onChange={(event: string) => {
                              set_wk_min_quota(event);
                              set_wk_autoscale_workspaceQuota(event);
                            }}>
                            {
                              autoQuotas.slice(0, autoQuotas.indexOf(wk_max_quota) + 1)
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      <Form.Item
                          key="max_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="max_quota" /><Tooltip placement="top"  title={<FormattedMessage id="max_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_max_quota}
                            className="w-75"
                            disabled={user_info.role === "workspaceOwner" ? true : false}
                            onChange={(event: string) => {
                              set_wk_max_quota(event)
                            }}>
                            {
                              autoQuotas.slice(autoQuotas.indexOf(wk_min_quota))
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      </div>
                      :
                      <div>
                        <Form.Item
                          key="min_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="min_quota" /><Tooltip placement="top"  title={<FormattedMessage id="min_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_min_quota}
                            className="w-75"
                            disabled={user_info.role === "workspaceOwner" ? true : false}
                            onChange={(event: string) => {
                              set_wk_min_quota(event)
                            }}>
                            {
                              (item_selected?.labels?.autoscale && item_selected?.quotaName && autoQuotas.includes(item_selected?.quotaName) ? autoQuotas.slice(0, autoQuotas.indexOf(wk_max_quota) + 1) : (quota_index ? autoQuotas.slice(0, quota_index) : autoQuotas)).map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      <Form.Item
                          key="max_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="max_quota" /><Tooltip placement="top"  title={<FormattedMessage id="max_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_max_quota}
                            className="w-75"
                            disabled={user_info.role === "workspaceOwner" ? true : false}
                            onChange={(event: string) => {
                              set_wk_max_quota(event)
                            }}>
                            {
                              (item_selected?.labels?.autoscale && item_selected?.quotaName && autoQuotas.includes(item_selected?.quotaName) ? autoQuotas.slice(autoQuotas.indexOf(wk_min_quota)) : autoQuotas.slice(quota_index))
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      </div>
                  }
                  </div>
                  <Form.Item
                    key="autoscaleWorkspaceQuota"
                    labelCol={{ sm: 5 }}
                    wrapperCol={{ sm: 14, offset: 5 }}
                    label={<FormattedMessage id="workspaceQuota" />}
                    hasFeedback
                    className="validate_icon">
                    <Input
                      value={wk_autoscale_workspaceQuota}
                      disabled={true}
                    ></Input>
                  </Form.Item>
                  <Form.Item>
                    <Descriptions size="small" column={2} bordered>
                      {autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota) &&
                        autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0]?.info &&
                        Object.keys(autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0].info).map((key: string) => (
                          <Descriptions.Item className="w-120 text-ellipsis w-max-100" label={`${key === 'configmaps' ? 'configmaps' : key === 'persistentvolumeclaims' ? 'PVC' : key === 'limitCPU' ? 'limitsCPU' : key === 'limitMemory' ? 'limitsMemory' : key}` + subscriptionKey(key, unit_provide)} key={key}>
                            {subscriptionValue(key, (autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0].info as key_value)[key], unit_provide)}
                          </Descriptions.Item>
                        ))}
                    </Descriptions>
                  </Form.Item>
                </div> : <div></div>
            }
          </Fragment>
        );
        set_workspace_auto_scale(workspace_auo_scale_new);
      }
    } else {
      if (path.includes('cluster-info/workspaces') && table_list_modal.visible && (table_list_modal.action === 0 || table_list_modal.action === 1) && user_info.role && user_info.role !== "") {
        const now_cpu = item_selected?.cpu?.totalCPU;
        const now_memory = item_selected?.memory?.totalMemory;
        const cpu_new_index = Number(now_cpu) >= 0 ? Math.ceil(Number(now_cpu) / 0.5) : 16;
        const memory_new_index = Number(now_memory) >= 0 ? Math.ceil(Number(now_memory) / 2048) : 16;
        const quota_index = cpu_new_index > memory_new_index ? cpu_new_index - 1 : memory_new_index - 1;
        const workspace_auo_scale_new: JSX.Element = (
          <Fragment>
            <Form.Item
              key="auto_scale"
              className={`${wk_auto_scale ? "autoscale_border_left autoscale_border_right autoscale_border_top mb-0 pb-24 pl-10 pt-10" : ""}` }
              labelCol={{ sm: 10 }}
              wrapperCol={{ sm: 14, offset: 0 }}
              label={<div><FormattedMessage id="auto_scale" /><Tooltip placement="top" title={<FormattedMessage id="auto_scale_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
              >
            <Switch disabled={(wk_auto_scale_disabled) ? true : false} checkedChildren="true" unCheckedChildren="false" checked={wk_auto_scale} onChange={(checked: boolean, event: Event) => { event.stopPropagation(); set_wk_auto_scale(checked); set_wk_auto_scale_false(checked ? '' : 'true'); }} />
            </Form.Item>
            {
              wk_auto_scale ?
                <div>
                  <div className={`${wk_auto_scale ? "autoscale_border_left autoscale_border_right autoscale_border_bottom mb-24" : ""}`}>
                  <Form.Item
                    key="defer_scale-in_for"
                    labelCol={{ sm: 9 }}
                    wrapperCol={{ sm: 15, offset: 0 }}
                    label={<div><FormattedMessage id="defer_scale-in_for" /><Tooltip placement="top"  title={<FormattedMessage id="defer_scale-in_for_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                    hasFeedback
                    className="validate_icon ml-40"
                    required={user_info.role === "workspaceOwner" ? false : true}>
                    <Select
                      defaultValue={wk_timeout}
                      className="w-75 ml-14"
                      disabled={wk_auto_scale_disabled ? true : false}
                      onChange={(event: string) => {
                        set_wk_timeout(event);
                      }}>
                      {
                        timeoutOptions.map((item_value: string) => <Option value={item_value} key={item_value} >{item_value}</Option>
                        )
                      }
                    </Select>
                    <span className="px-6"><FormattedMessage id="minutes" /></span>
                  </Form.Item>
                  {
                    table_list_modal.action === 0 ?
                      <div>
                        <Form.Item
                          key="min_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="min_quota" /><Tooltip placement="top"  title={<FormattedMessage id="min_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_min_quota}
                            className="w-75"
                            disabled={wk_auto_scale_disabled ? true : false}
                            onChange={(event: string) => {
                              set_wk_min_quota(event);
                              set_wk_autoscale_workspaceQuota(event);
                            }}>
                            {
                              autoQuotas.slice(0, autoQuotas.indexOf(wk_max_quota) + 1)
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      <Form.Item
                          key="max_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="max_quota" /><Tooltip placement="top"  title={<FormattedMessage id="max_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_max_quota}
                            className="w-75"
                            disabled={wk_auto_scale_disabled ? true : false}
                            onChange={(event: string) => {
                              set_wk_max_quota(event)
                            }}>
                            {
                              autoQuotas.slice(autoQuotas.indexOf(wk_min_quota))
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      </div>
                      :
                      <div>
                        <Form.Item
                          key="min_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="min_quota" /><Tooltip placement="top"  title={<FormattedMessage id="min_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_min_quota}
                            className="w-75"
                            disabled={wk_auto_scale_disabled ? true : false}
                            onChange={(event: string) => {
                              set_wk_min_quota(event)
                            }}>
                            {
                              (item_selected?.labels?.autoscale && item_selected?.quotaName && autoQuotas.includes(item_selected?.quotaName) ? autoQuotas.slice(0, autoQuotas.indexOf(wk_max_quota) + 1) : (quota_index ? autoQuotas.slice(0, quota_index) : autoQuotas)).map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      <Form.Item
                          key="max_quota"
                          labelCol={{ sm: 9 }}
                          wrapperCol={{ sm: 15, offset: 0 }}
                          label={<div><FormattedMessage id="max_quota" /><Tooltip placement="top"  title={<FormattedMessage id="max_quota_desc"></FormattedMessage>}><QuestionCircleOutlined className="autoscale_help" /></Tooltip></div>}
                          hasFeedback
                          className="validate_icon ml-40"
                          required={user_info.role === "workspaceOwner" ? false : true}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultValue={wk_max_quota}
                            className="w-75"
                            disabled={wk_auto_scale_disabled ? true : false}
                            onChange={(event: string) => {
                              set_wk_max_quota(event)
                            }}>
                            {
                              (item_selected?.labels?.autoscale && item_selected?.quotaName && autoQuotas.includes(item_selected?.quotaName) ? autoQuotas.slice(autoQuotas.indexOf(wk_min_quota)) : autoQuotas.slice(quota_index))
                                .map((item_value: string, index: number) => <Option value={item_value} key={item_value} >{item_value}</Option>
                                )
                            }
                          </Select>
                        </Form.Item>
                      </div>
                  }
                  </div>
                  <Form.Item
                    key="autoscaleWorkspaceQuota"
                    labelCol={{ sm: 5 }}
                    wrapperCol={{ sm: 14, offset: 5 }}
                    label={<FormattedMessage id="workspaceQuota" />}
                    hasFeedback
                    className="validate_icon">
                    <Input
                      value={wk_autoscale_workspaceQuota}
                      disabled={true}
                    ></Input>
                  </Form.Item>
                  <Form.Item>
                    <Descriptions size="small" column={2} bordered>
                      {autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota) &&
                        autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0]?.info &&
                        Object.keys(autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0].info).map((key: string) => (
                          <Descriptions.Item className="w-120 text-ellipsis w-max-100" label={`${key === 'configmaps' ? 'configmaps' : key === 'persistentvolumeclaims' ? 'PVC' : key === 'limitCPU' ? 'limitsCPU' : key === 'limitMemory' ? 'limitsMemory' : key}` + subscriptionKey(key, unit_provide)} key={key}>
                            {subscriptionValue(key, (autoQuotasInfo.filter((item: any) => item.name === wk_autoscale_workspaceQuota)[0].info as key_value)[key], unit_provide)}
                          </Descriptions.Item>
                        ))}
                    </Descriptions>
                  </Form.Item>
                </div> : <div></div>
            }
          </Fragment>
        );
        set_workspace_auto_scale(workspace_auo_scale_new);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enable_autoscale, workspaces, wk_auto_scale, wk_min_quota, wk_max_quota, wk_autoscale_workspaceQuota, subscriptionKey, subscriptionValue, unit_provide, item_selected?.name, table_list_modal.action, table_list_modal.visible, path, autoQuotas, autoQuotasInfo, user_info.role, wk_auto_scale_disabled, type_name])

  return (
    <div>
      {table_list_modal.visible ? (
        <Modal
          className={table_list_modal.is_web_kubectl ? "terminal" : `App ${theme}`}
          width={
            table_list_modal.is_logs || table_list_modal.is_config || table_list_modal.is_details || table_list_modal.is_yaml || table_list_modal.is_web_kubectl || table_list_modal.is_edit_yaml || table_list_modal.is_view_yaml || table_list_modal.is_restartLogs
              ? "80vw"
              : 740
          }
          bodyStyle={table_list_modal.is_web_kubectl ? { padding: 0, lineHeight: 0, height: "100%" } : {}}
          title={table_list_modal.modal_title}
          visible={table_list_modal.visible}
          onOk={handle_ok}
          onCancel={handle_cancel}
          destroyOnClose={true}
          okButtonProps={{ disabled: table_list_modal.modal_ok_button }}
          okText={formatMessage({ id: "ok" })}
          cancelText={formatMessage({ id: "cancel" })}
          maskClosable={false}
          {...footer}
        >
          {table_list_modal.modal_message}
        </Modal>
      ) : (
          ""
        )}
    </div>
  );
};

export default injectIntl(withRouter(TableListModal) as any);
